/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import TEXT from "../../../../../src/utils/globalText";
import ICONS from "../../../../assets/Icons";
import BeneAccountViewAllPopup from "../../../../components/Accounts/BeneAccount/BeneAccountViewAllPopup";
import AdditionalRecipient from "../../../../components/AdditionalRecipient";
import FullScreen from "../../../../components/FullScreen";
import Loader from "../../../../components/Loader/Index";
import useServiceChecker from "../../../../components/ServiceChecker";
import CommonAlertsStrip from "../../../../components/_utils/CommonAlertsStrip";
import CommonBankLogo from "../../../../components/_utils/CommonBankLogo";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs";
import TopNavLargeButton from "../../../../components/_utils/CommonButtons/TopNavLargeButton";
import TopNavSmallButton from "../../../../components/_utils/CommonButtons/TopNavSmallButton";
import CommonContainerCard from "../../../../components/_utils/CommonContainerCard";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard";
import CommonAssignLabelPopup from "../../../../components/_utils/CommonPopups/CommonAssignLabelPopup";
import EditCommonPopup from "../../../../components/_utils/CommonPopups/CommonEditPopup";
import LargePopupRedirect from "../../../../components/_utils/CommonPopups/CommonLargePopupRedirect";
import SmallPopup from "../../../../components/_utils/CommonSmallPopup";
import SmallPopupWithInput from "../../../../components/_utils/CommonSmallPopupWithInput";
import CommonToast from "../../../../components/_utils/CommonToast";
import TopNavComponent from "../../../../components/_utils/CommonTopNav/TopNavComponent";
import { formatAccountNumber } from "../../../../components/_utils/FormatAccountNumber";
import TickerAnimation from "../../../../components/_utils/TickerAnimation";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair";
import UniversalRefreshToast from "../../../../components/_utils/UniversalRefreshToast";
import OwnerAccountIFSC from "../../../../containers/Accounts/OwnerAccount/OwnerAccountIFSC";
import GSTVerification from "../../../../containers/Settings/GSTDetails";
import PanVerification from "../../../../containers/Settings/PanVerification";
import {
  editBeneficiary,
  resetEditBankBeneficiary,
  resetEditBeneficiary,
} from "../../../../redux/features/accounts/BeneficiaryAccount/createAccount";
import {
  addNewLabel,
  beneBankLookUp,
  beneDeniedAccount,
  beneVerifyThisPAN,
  beneWaitingApproved,
  removeNewLabel,
} from "../../../../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import {
  beneTxnMultiDeniedApproval,
  beneTxnViewAllAcc,
} from "../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import {
  getRefreshTokenNew,
  resetServices,
} from "../../../../redux/features/refreshToken/refreshToken";
import { schedulesTxnReject } from "../../../../redux/features/scheduleTransaction";
import {
  achivedAccountDetail,
  beneLookUp,
  resetInEdit,
  unachivedAccountDetail,
  viewAccountDetail,
} from "../../../../redux/features/verifyPAN/verifyPAN";
import accountNameStandardised from "../../../../utils/accountNamestandardised";
import {
  GlobalConfiguration,
  IntervalConfiguration,
  PaginationConfiguration,
  ScreenSizeConfiguration,
  TimelineConfiguration,
} from "../../../../utils/configurationProvider";
import formatDateViewAll from "../../../../utils/formatDateViewAll";
import { linkIdentifier } from "../../../../utils/linkIdentifier";
import useCategories from "../../../../utils/useCategories";
import BeneficiaryTransactionViewall from "../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall";
import ScheduleBeneficiaryTransactionViewSchedules from "../../../Transactions/ScheduleBeneficiaryTransactions/ScheduleBeneficiaryTransactionViewSchedules";
import "./index.css";
import DeclinedPopup from "../BeneficiaryAcountApproval/DeclinedPopup";

const BeneficiaryAccountDetails = (payload) => {
  const [ensureAll] = useServiceChecker();
  const categoryMapper = useCategories();
  const navigate = useNavigate();
  const location = useLocation();
  const { id } = useParams();
  const dispatch = useDispatch();
  const popupRef = useRef(null);
  const [labels, setLabels] = useState([]);
  const [remPan, setRemPan] = useState("");
  const [remIFSC, setRemIFSC] = useState("");
  const [category, setCategory] = useState("");
  const [loading, setLoading] = useState(true);
  const [deniedId, SetdeniedId] = useState(null);
  const [recipients, setRecipients] = useState([]);
  const [remAccount, setRemAccount] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [clickedBtn, setClickedBtn] = useState(null);
  const [nameArchive, setNameArchive] = useState("");
  const [showLoader, setShowLoader] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [alertPopUp, setAlertPopUp] = useState(false);
  const [activeType, setActiveType] = useState("pan");
  const [labelDetails, setLabelDetails] = useState([]);
  const [openHistory, setOpenHistory] = useState(false);
  const [declineReason, setDeclineReason] = useState("");
  const [pendingTxnId, setpendingTxnId] = useState(null);
  const [showGstPopup, setGstShowPopup] = useState(false);
  const [showPanPopup, setPanShowPopup] = useState(false);
  const [showIfscPopup, setIfscShowPopup] = useState(false);
  const [achivedOpenPop, setAchivedOpenPop] = useState(false);
  const [associatePending, setassociatePending] = useState("");
  const [showPopupReject, setshowPopupReject] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [showLabelsPopup, setShowLabelsPopup] = useState(false);
  const [associateschedule, setassociateschedule] = useState("");
  const [openTransHistory, setOpenTransHistory] = useState(false);
  const [unachivedOpenPop, setUnachivedOpenPop] = useState(false);
  const [showRejectTnxPopup, setRejectTxnPopup] = useState(false);
  const [selectedChipIndex, setSelectedChipIndex] = useState(null);
  const [ViewAccountDetails, SetViewAccountDetails] = useState([]);
  const [openBeneAssociate, setOpenBeneAssociate] = useState(false);
  const [preventMultiEnter, setPreventMultiEnter] = useState(false);
  const [showAssignedLabels, setShowAssignedLabels] = useState(false);
  const [additionalRecipient, setAdditionalRecipicent] = useState(false);
  const [showScheduleTxnPopup, setShowScheduleTxnPopup] = useState(false);
  const [showAdditionalSection, setShowAdditionalSection] = useState(false);
  // const [openInternalAssociate, setOpenInternalAssociate] = useState(false);
  const [showAdditionalRecipient, setShowAdditionalRecipient] = useState([]);
  const [recipientButtonDisabled, setRecipientButtonDisabled] = useState(true);
  const [additionalChip, setAdditionalChip] = useState(showAdditionalRecipient);
  const [labelLoading, setLabelLoading] = useState(false);
  const [isMobile, setIsMobile] = useState(
    window.innerWidth <= ScreenSizeConfiguration?.mobileScreen,
  );
  const [showCategories, setShowCategories] = useState(
    payload?.showCategory ?? false,
  );
  const [showContactDetails, setShowContactDetails] = useState(
    payload?.showCategory ? false : true,
  );

  const [currentAccountDetails, setCurrentAccountDetails] = useState({
    name: "",
    bank_name: "",
    ifsc_code: "",
    bank_acc_no: "",
    category: "",
    id: "",
    pan: "",
    bank_account_holder_full_name: "",
  });

  let label;

  const [bankDetails, setBankDetails] = useState({
    name: "",
    bankAccountNumber: "",
    ifscCode: "",
  });
  const [previousContactDetails, setPreviousContactDetails] = useState({
    legalName: "",
    contact: "",
    email: "",
    gstin: "",
    category: null,
  });

  const [index, setIndex] = useState(
    showContactDetails
      ? GlobalConfiguration?.lengthCheckZero
      : showCategories
        ? GlobalConfiguration?.lengthCheckOne
        : showAssignedLabels
          ? GlobalConfiguration?.lengthCheckTwo
          : additionalRecipient
            ? GlobalConfiguration?.lengthCheckThree
            : GlobalConfiguration?.lengthCheckZero,
  );
  const [prevIndex, setPrevIndex] = useState(
    GlobalConfiguration?.lengthCheckZero,
  );
  const [animationClass, setAnimationClass] = useState("");

  //useSelector
  const { beneTxnViewAllAccData, beneTxnViewAllAccLoading } = useSelector(
    (state) => state.beneTxnViewAccData,
  );
  const { schedulesTxnViewAllData } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );
  const accountType = location.pathname.includes("beneficiary_account")
    ? "beneficiary"
    : location.pathname.includes("internal_account")
      ? "internal"
      : "";
  const pathName = location?.state?.from ? location?.state?.from : "";
  const txn_single_appr = location?.state?.type ? location?.state?.type : "";

  const { viewAccountDetailData, viewAccountDetailLoading } = useSelector(
    (state) => state.verify,
  );
  const { beneDeniedApprovalData } = useSelector(
    (state) => state.beneAllVerification,
  );

  const { schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  const services = useSelector((state) => state.refreshToken.services);

  const sliceCategory = useSelector(
    (state) => state.beneAllVerification.beneTransCategories.categories,
  );

  const { beneLookData } = useSelector((state) => state.verify);

  const bankData = useSelector(
    (state) => state.beneAllVerification.beneLookData,
  );

  const { beneDeniedApprovalLoading } = useSelector(
    (state) => state.beneAllVerification,
  );

  useLayoutEffect(() => {
    if (index !== prevIndex) {
      const direction =
        index > prevIndex ? "animate-slide-next" : "animate-slide-prev";

      setAnimationClass(direction);
      setPrevIndex(index);
    }
  }, [index]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.beneficiary_accounts &&
      viewAccountDetailData.beneficiary_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { pan_legal_name, contact_no, email_id } =
        viewAccountDetailData.beneficiary_accounts[0];
      setPreviousContactDetails({
        legalName: pan_legal_name,
        contact: contact_no,
        email: email_id,

        category: category || null,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.beneficiary_accounts &&
      viewAccountDetailData.beneficiary_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { category } = viewAccountDetailData.beneficiary_accounts[0];
      setCategory(category);
    }
  }, [viewAccountDetailData]);

  const handleInputChange = (event) => {
    const sanitizedValue = event.target.value
      .replace(/\s+/g, " ")
      .replace(/^\s/, "")
      .slice(0, 150);

    setDeclineReason(sanitizedValue);
  };
  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.beneficiary_accounts &&
      viewAccountDetailData.beneficiary_accounts.length >
        GlobalConfiguration.lengthCheckZero
    ) {
      const { bank_acc_no, name, ifsc_code } =
        viewAccountDetailData.beneficiary_accounts[0];
      setBankDetails({
        bankHolderName: name,
        bankAccountNumber: bank_acc_no,
        ifscCode: ifsc_code,
      });
    }
  }, [viewAccountDetailData]);

  function handleChipClick(id) {
    setSelectedChipIndex(id);
  }

  const chipsArray = [
    {
      text: "IFSC code",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckZero,
      disabled: false,
      hoverOption: "white",
      bulletPoint: [
        "Please contact an Xpentra administrator to change the IFSC detail.",
      ],
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckZero),
    },
    {
      text: "Name, Contact number, Email ID",
      selected: selectedChipIndex === GlobalConfiguration.lengthCheckOne,
      disabled: false,
      bulletPoint: ["Require approval"],
      hoverOption: "white",
      onClick: () => handleChipClick(GlobalConfiguration.lengthCheckOne),
    },
    {
      text: "Categories",
      selected: selectedChipIndex === TimelineConfiguration.barWidthMedium,
      disabled: false,
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckTwo),
      bulletPoint: ["Require approval"],
      hoverOption: "white",
    },
    {
      text: "PAN number, GST number",
      selected: selectedChipIndex === TimelineConfiguration.barWidthLarge,
      disabled: false,
      bulletPoint: ["Require approval"],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckThree),
      hoverOption: "white",
    },
    {
      text: "Bank account number",
      selected: selectedChipIndex === GlobalConfiguration?.lengthCheckFour,
      disabled: false,
      bulletPoint: [
        "Require approval",
        "Creates a new account",
        "Archives the old account",
      ],
      onClick: () => handleChipClick(GlobalConfiguration?.lengthCheckFour),
      hoverOption: "white",
    },
  ];

  const handleAlertSchedule = () => {
    setshowPopupReject(true);
  };

  const handleAccRejectAlert = () => {
    // setRejectTxnPopup(false);
    setshowPopupReject(true);
  };

  const handleConfirmDecline = async (id, AccountIdData) => {
    setShowLoader(true);
    setshowPopupReject(false);
    UniversalRefreshToast("accountsRefresh");

    if (!beneDeniedApprovalLoading || beneDeniedApprovalLoading === null) {
      const data = await dispatch(beneDeniedAccount({ id, AccountIdData }));
      if (
        data?.payload?.errors?.user_unauthorized?.length >
        GlobalConfiguration?.lengthCheckZero
      ) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "ABeneficiaryTxn",
          },
        });
        return;
      }

      setShowLoader(true);

      await new Promise((resolve) => {
        setTimeout(resolve, IntervalConfiguration.intervalExtraLarge);
      });
      toast.dismiss();
      if (data?.payload?.status === false || data?.payload === undefined) {
        let error_msg = "";
        let error_list = null;
        if (data?.payload === undefined) {
          error_msg = "An error occured while taking action on this account";
        } else if (data?.payload?.errors?.beneficiary_account) {
          if (
            data?.payload?.errors?.beneficiary_account?.length >
            GlobalConfiguration?.lengthCheckOne
          ) {
            error_list = data?.payload?.errors?.beneficiary_account;
            error_msg = data?.payload?.errors?.beneficiary_account[0];
          } else {
            error_msg = data?.payload?.errors?.beneficiary_account;
            // CommonToast({
            //   text: error_msg[0],
            //   icon: ICONS?.ERROR_WHITE_CIRCLE,
            //   variant: "var(--error)",
            //   buttonNeeded: false,
            // });
          }
        } else if (data?.payload?.status === false) {
          error_msg = data?.payload?.errors?.category?.[0];
        } else if (data?.payload?.errors?.bank_account_number?.[0]) {
          error_msg = data?.payload?.errors?.bank_account_number[0];
        }

        if (error_msg === "Beneficiary account already rejected") {
          const newData = await dispatch(viewAccountDetail({ id }));
          const updatedBeneficiaryAccount = {
            ...newData?.payload?.beneficiary_accounts?.[0],
            error_msg,
            error: data?.payload?.status === false ? true : false,
          };

          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                ...(updatedBeneficiaryAccount || {}),
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
        } else {
          const updatedData = ViewAccountDetails?.map((item) => {
            if (item.id === id) {
              return {
                ...item,
                error_msg,
                error: data?.payload?.status === false ? true : false,
              };
            }
            return item;
          });
          updateAllAccounts(updatedData);
        }
        setTimeout(
          () => setShowLoader(false),
          IntervalConfiguration.intervalExtraLarge,
        );
        setDeclineReason("");
        handleClosePopup();
        if (
          Array.isArray(error_list) &&
          error_list.length > GlobalConfiguration?.lengthCheckOne
        ) {
          error_list.forEach((err) => {
            setTimeout(() => {
              CommonToast({
                text: err,
                icon: ICONS?.ERROR_WHITE_CIRCLE,
                variant: "var(--error)",
                buttonNeeded: false,
              });
            }, IntervalConfiguration?.intervalSmall);
          });
        } else {
          CommonToast({
            text: error_msg,
            icon: ICONS?.ERROR_WHITE_CIRCLE,
            variant: "var(--error)",
            buttonNeeded: false,
          });
        }
      } else {
        const updatedData = ViewAccountDetails?.map((item) => {
          if (item.id === id) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "rejected" : "pending",

              rejected_on:
                data?.payload?.status === true
                  ? data?.payload?.beneficiary_accounts[0]?.rejected_on
                  : "",
              rejected_by_name:
                data?.payload?.status === true
                  ? data?.payload?.beneficiary_accounts[0]?.rejected_by_name
                  : "",
              rejection_reason: AccountIdData,
              error:
                item.error === false && data?.payload?.status === false
                  ? true
                  : false,
              message:
                item.message === "" && data?.payload?.status === false
                  ? data?.payload?.errors?.beneficiary_account[0]
                  : "",
            };
          }
          return item;
        });
        updateAllAccounts(updatedData);
        setShowLoader(false);
        setDeclineReason("");
        setRejectTxnPopup(false);
        handleClosePopup();
        CommonToast({
          text: "Account rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        if (payload?.type === "bene_account_detail_modal") {
          setTimeout(() => {
            payload?.closeBeneAccountDetailModal();
            window.location.reload();
          }, IntervalConfiguration.intervalExtraLarge);
        }
        if (pathName) {
          setTimeout(() => {
            navigate(pathName);
          }, IntervalConfiguration.intervalPopup);
        }
      }
    }
  };

  const handleApply = () => {
    dispatch(resetServices());
    dispatch(getRefreshTokenNew());
    dispatch(resetEditBeneficiary());
    dispatch(resetEditBankBeneficiary());

    switch (selectedChipIndex) {
      case 0: // IFSC Code
        break;

      case 1: // Account name, Contact number, Email
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/contact_details/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 2: // Assigned categories
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/categories/${id}`,
          {
            state: previousContactDetails,
          },
        );
        break;

      case 3: // PAN Number, GST
        dispatch(resetInEdit());
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/PAN_Details/${id}`,
        );
        break;

      case 4: // Bank account number
        navigate(
          `/beneficiary_account_dashboard/beneficiary_account_view_all/beneficiary_account_detail_page/Bank_Details/${id}`,
          {
            state: bankDetails,
          },
        );
        dispatch(resetEditBankBeneficiary());
        break;

      default:
        break;
    }
  };

  async function fetchData() {
    if (showLabelsPopup) {
      setLoading(false);
    } else if (!showLabelsPopup) {
      setLoading(true);
    }
    try {
      let response;
      if (payload?.type === "bene_account_detail_modal") {
        response = await dispatch(
          viewAccountDetail({ id: payload?.bene_account_id }),
        );
        setLabelDetails(
          response?.payload?.beneficiary_accounts?.[0]?.labels || [],
        );
      } else {
        response = await dispatch(viewAccountDetail({ id }));
        setLabelDetails(
          response?.payload?.beneficiary_accounts?.[0]?.labels || [],
        );
        setShowAdditionalRecipient(
          response?.payload?.beneficiary_accounts?.[0]?.recipient_email || [],
        );
        setAdditionalChip(
          response?.payload?.beneficiary_accounts?.[0]?.recipient_email || [],
        );
      }
      if (response?.error?.message === "Request failed with status code 404") {
        navigate("/*");
      }
    } catch (error) {
      setLoading(false);
      error("Failed to load the account details", error);
    } finally {
      setLoading(false);
    }
  }
  const finalRecipients = [...new Set([...recipients, ...additionalChip])];

  const handleConfirm = async () => {
    if (recipientButtonDisabled) return;
    const recipientString = [...recipients, ...additionalChip].join(",");
    let response = await dispatch(
      editBeneficiary({ id: id, recipient_email: recipientString }),
    );
    if (response?.payload?.status) {
      setShowAdditionalSection(false);
      await fetchData();
      setRecipients([]);
    } else {
      setShowAdditionalSection(false);
    }
  };
  const handleClose = () => {
    setShowLabelsPopup(false);
    fetchData();
  };
  const handleModalClose = () => {
    setIsEditModalOpen(false);
  };

  const handlePANDetails = async (pan) => {
    if (pan?.length === GlobalConfiguration?.panLength) {
      const response = await dispatch(
        beneVerifyThisPAN({ search_string: pan }),
      );
      if (response?.payload?.status === true) {
        setPanShowPopup(true);
      } else if (response?.payload?.errors?.user_unauthorized?.[0]) {
        navigate("/feature_not_assigned", {
          state: {
            unavailableService: "BUAccount",
          },
        });
      } else if (response?.payload?.status === false) {
        CommonToast({
          text: response?.payload?.errors?.base[0],
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
      }
    }
  };

  useEffect(() => {
    const TransactionData = async () => {
      let data = await dispatch(
        beneTxnViewAllAcc({
          beneficiary_account_id:
            viewAccountDetailData?.beneficiary_accounts?.[0]?.id,
          lifecycle_status: "pending",
        }),
      );
      setpendingTxnId(data.payload.transactions?.[0]?.txn_id);
    };
    if (viewAccountDetailData) TransactionData();
  }, [viewAccountDetailData]);

  const isArchived =
    viewAccountDetailData?.beneficiary_accounts[0]?.approval_status ===
    "archived";

  const hasALabel = services?.includes("ALabel");
  const hasRLabel = services?.includes("RLabel");

  const isServiceMissing = !(hasALabel && hasRLabel);

  const handleClick = () => {
    if (isArchived) return;

    if (isServiceMissing) {
      navigate("/feature_not_assigned", {
        state: { unavailableService: "ALabel,RLabel" },
      });
    } else {
      setShowLabelsPopup(true);
    }
  };

  if (
    payload.internalAccount === "internalAccount" &&
    services?.find(
      (service) => service === "BAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.beneficiary_accounts[0]?.approval_status ===
      "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else if (payload.internalAccount === "internalAccount") {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  } else if (
    services?.find(
      (service) => service === "BAAccountArchive" || service === "Admin",
    ) === undefined &&
    viewAccountDetailData?.beneficiary_accounts[0]?.approval_status ===
      "archived"
  ) {
    label = (
      <>
        Unarchive <br /> account{" "}
      </>
    );
  } else {
    label = (
      <>
        Archive <br /> account{" "}
      </>
    );
  }

  const handleModalOpen = (id) => {
    setIsEditModalOpen(id);
  };
  const handleCloseModal = () => {
    if (accountType === "beneficiary") {
      setAchivedOpenPop(false);
      setOpenBeneAssociate(false);
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(false);
      setAchivedOpenPop(false);
    }
  };
  const actionRestricted = () => {
    CommonToast({
      text: "Action restricted in popup mode.",
      icon: ICONS?.ERROR_WHITE_CIRCLE,
      variant: "var(--error)",
    });
  };
  const transactionImage =
    payload.internalAccount === "internalAccount"
      ? null
      : ICONS?.PAY_WITH_CIRCLE;
  const handleUnarchive = () => {
    setUnachivedOpenPop(true);
    if (viewAccountDetailData?.beneficiary_accounts[0]?.archived === "N") {
      setUnachivedOpenPop(false);
    } else {
      setUnachivedOpenPop(true);
    }
  };
  const handleArchive = () => {
    if (viewAccountDetailData?.beneficiary_accounts[0]?.archived === "N") {
      setAchivedOpenPop(true);
    } else {
      setAchivedOpenPop(false);
    }
  };

  const toggleCategories = () => {
    setShowCategories(true);
    setShowContactDetails(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
    setIndex(GlobalConfiguration?.lengthCheckOne);
  };

  const toggleContactDetails = () => {
    setShowContactDetails(true);
    setShowCategories(false);
    setShowAssignedLabels(false);
    setAdditionalRecipicent(false);
  };

  const toggleAssignedLabels = () => {
    setShowAssignedLabels(true);
    setShowCategories(false);
    setShowContactDetails(false);
    setAdditionalRecipicent(false);
  };

  const toggleAdditionalRecipicent = () => {
    setAdditionalRecipicent(true);
    setShowAssignedLabels(false);
    setShowCategories(false);
    setShowContactDetails(false);
  };

  const openTransactionHistory = () => {
    if (payload?.internalAccount === "internalAccount") {
      setOpenHistory(true);
    } else {
      setOpenTransHistory(true);
    }
  };

  const asAcc =
    viewAccountDetailData?.beneficiary_accounts[0]?.associate_bank === "Y" ||
    viewAccountDetailData?.beneficiary_accounts[0]?.associate_pan === "Y";

  const pendingTxn =
    viewAccountDetailData?.beneficiary_accounts[0]
      ?.pending_beneficiary_transactions === "Y";

  const associatedCategories =
    viewAccountDetailData?.beneficiary_accounts?.[0]?.all_category_assign ===
    "Y";

  const scheduleTxn =
    viewAccountDetailData?.beneficiary_accounts[0]
      ?.pending_scheduled_beneficiary_transactions === "Y";

  const buildAlerts = () => [
    ...(associatedCategories !== undefined
      ? associatedCategories
        ? [
            {
              isLoading: false,

              text: "All categories are assigned to this account",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                toggleCategories();
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking category assign",
          },
        ]),
    ...(asAcc !== undefined
      ? asAcc
        ? [
            {
              isLoading: false,
              isDisabled: payload?.type === "bene_account_detail_modal",
              text: "Associated accounts are found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload?.type === "bene_account_detail_modal") {
                  actionRestricted();
                } else {
                  setRemPan(currentAccountDetails.pan);
                  openAssociatedAccountsFound();
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking associated account",
          },
        ]),

    ...(pendingTxn !== undefined
      ? pendingTxn &&
        viewAccountDetailData?.beneficiary_accounts[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: payload?.type === "bene_account_detail_modal",
              text: "Pending transactions found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload?.type === "bene_account_detail_modal") {
                  actionRestricted();
                  return;
                } else {
                  const hasAccess =
                    services?.includes("ABeneficiaryTxn") ||
                    services?.includes("Admin");

                  if (!hasAccess) {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "ABeneficiaryTxn" },
                    });
                    return;
                  }

                  setRejectTxnPopup(true);
                  setassociatePending("AlertPendingTxn");
                  setassociateschedule("");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking pending transactions",
          },
        ]),

    ...(scheduleTxn !== undefined
      ? scheduleTxn &&
        viewAccountDetailData?.beneficiary_accounts[0]?.approval_status ===
          "pending"
        ? [
            {
              isLoading: false,
              isDisabled: payload?.type === "bene_account_detail_modal",
              text: "Pending schedules found",
              icon: "https://q2pay.in/new_assets/common/dashboard/alert.svg",
              onClick: () => {
                if (payload?.type === "bene_account_detail_modal") {
                  actionRestricted();
                  return;
                } else {
                  const hasAccess =
                    services?.includes("BAScheduledTxn") ||
                    services?.includes("Admin");

                  if (!hasAccess) {
                    navigate("/feature_not_assigned", {
                      state: { unavailableService: "BAScheduledTxn" },
                    });
                    return;
                  }

                  setShowScheduleTxnPopup(true);
                  setassociateschedule("AlertSchedule");
                  setassociatePending("");
                }
              },
            },
          ]
        : []
      : [
          {
            isLoading: false,
            text: "Checking schedules transactions",
          },
        ]),
  ];

  const closeTransactionHistory = () => {
    setOpenTransHistory(false);
  };

  const handleRejectAllTransaction = async () => {
    setShowLoader(true);

    const AccountIdData = declineReason;
    let id2 = [];

    id2 =
      !beneTxnViewAllAccLoading &&
      beneTxnViewAllAccData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
        ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
        : [];

    UniversalRefreshToast("Rejecting transaction");

    let data = null;

    if (id2.length > GlobalConfiguration?.lengthCheckZero) {
      data = await dispatch(
        beneTxnMultiDeniedApproval({ id: id2, AccountIdData }),
      );
    } else {
      data = { payload: { status: true } };
    }

    if (
      data?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      const serviceKey = "ABeneficiaryTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) =>
      setTimeout(resolve, IntervalConfiguration?.intervalExtraLarge),
    );

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowLoader(false);
    } else if (data?.payload?.status) {
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      await dispatch(viewAccountDetail({ id: id }));
      if (
        viewAccountDetailData?.beneficiary_accounts[0]
          ?.pending_scheduled_beneficiary_transactions === "Y"
      ) {
        setShowScheduleTxnPopup(true);
        setRejectTxnPopup(false);
      } else {
        if (payload.type === "bene_account_detail_modal") {
          setTimeout(() => {
            handleConfirmDecline(payload?.bene_account_id, declineReason);
          }, IntervalConfiguration.intervalSmaller);
        } else {
          setTimeout(() => {
            handleConfirmDecline(id, declineReason);
          }, IntervalConfiguration.intervalSmaller);
        }
      }
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });

      setTimeout(() => {
        setRejectTxnPopup(false);
      }, IntervalConfiguration.intervalMedium);
      setDeclineReason("");
    }

    if (payload?.flow === "schedule_single_approval") {
      setTimeout(() => {
        payload?.closeBeneAccountDetailModal();
        window.location.reload();
      }, IntervalConfiguration?.intervalExtraLarger);
    }
  };

  const handleRejectAlert = async () => {
    setShowLoader(true);

    const queryParams = {
      page_no: GlobalConfiguration.lengthCheckOne,
      page_item_count: PaginationConfiguration.paginationSmall,
      lifecycle_status: "pending",
      beneficiary_account_id: id,
    };

    const response = await dispatch(beneTxnViewAllAcc(queryParams));
    const data = response?.payload?.transactions;

    if (
      data?.length > GlobalConfiguration.lengthCheckZero &&
      response?.payload?.status === true
    ) {
      setShowLoader(false);
      handleConfirmAlert(data);
      setRejectTxnPopup(false);
      setshowPopupReject(false);
    }
  };

  const handleConfirmAlert = async (transactions) => {
    try {
      const AccountIdData = declineReason;

      const ids = transactions?.map((t) => t.txn_id) || [];

      UniversalRefreshToast("Rejecting transaction");

      if (ids.length > GlobalConfiguration?.lengthCheckZero) {
        const data = await dispatch(
          beneTxnMultiDeniedApproval({ id: ids, AccountIdData }),
        );

        if (data?.payload?.status === true) {
          CommonToast({
            text: "Transaction rejected successfully.",
            icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
            variant: "var(--success)",
            btnProps: {
              isDisabled: false,
              enabledTextColor: "var(--text-primary)",
              enabledBgColor: "var(--primary-bg)",
            },
          });
          setDeclineReason("");
        }
      }
      await dispatch(viewAccountDetail({ id: id }));
      setDeclineReason("");
    } catch (error) {
      CommonToast({
        text: "Something went wrong. Please try again",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
  };

  const handleRejectTransactionChecker = async (id, AccountIdData) => {
    setShowLoader(true);

    if (
      viewAccountDetailData?.beneficiary_accounts[0]
        ?.pending_beneficiary_transactions === "Y"
    ) {
      setshowPopupReject(false);
      setRejectTxnPopup(true);
      setShowLoader(false);

      setPreventMultiEnter(true);
    } else if (
      viewAccountDetailData?.beneficiary_accounts[0]
        ?.pending_scheduled_beneficiary_transactions === "Y"
    ) {
      setshowPopupReject(false);
      setShowScheduleTxnPopup(true);

      setShowLoader(false);
    } else {
      handleConfirmDecline(id, AccountIdData);
    }
    await dispatch(viewAccountDetail({ id: id }));
  };

  const openAssociatedAccountsFound = () => {
    dispatch(beneLookUp({ pan_number: currentAccountDetails.pan }));
    dispatch(
      beneBankLookUp({
        ifsc: currentAccountDetails.ifsc_code,
        bank_account_no: currentAccountDetails.bank_acc_no,
        bank_account_holder_full_name:
          currentAccountDetails.bank_account_holder_full_name,
      }),
    );

    if (accountType === "beneficiary") {
      setOpenBeneAssociate(true);
    }
  };

  const createTransaction = () => {
    if (
      services?.find(
        (service) => service === "BUAccount" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails.category.length >
        GlobalConfiguration?.lengthCheckZero &&
      payload.internalAccount === "internalAccount"
    ) {
      navigate("/internal_transaction_dashboard/create_internal_transaction", {
        state: currentAccountDetails,
      });
    } else if (
      services?.find(
        (service) => service === "BUAccount" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails.category.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      navigate(
        "/beneficiary_transaction_dashboard/create_beneficiary_transaction",
        {
          state: currentAccountDetails,
        },
      );
    } else if (
      services?.find(
        (service) => service === "BUAccount" || service === "Admin",
      ) !== undefined &&
      currentAccountDetails.category.length <=
        GlobalConfiguration?.lengthCheckZero
    ) {
      CommonToast({
        text: "Category can't be blank",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    }
  };

  const handleApprovalDetails = async (id) => {
    setShowLoader(true);
    setTimeout(
      () => setShowLoader(false),
      IntervalConfiguration.intervalMedium,
    );
    let response;
    UniversalRefreshToast("approvalaccountsRefresh");

    if (payload?.type === "bene_account_detail_modal") {
      response = await dispatch(beneWaitingApproved(payload?.bene_account_id));
    } else {
      response = await dispatch(beneWaitingApproved(id));
    }
    toast.dismiss();
    if (
      response?.payload?.errors?.user_unauthorized?.length >
      GlobalConfiguration?.lengthCheckZero
    ) {
      navigate("/feature_not_assigned", {
        state: {
          unavailableService: "BAAccount",
        },
      });
      return;
    }
    if (
      response?.payload?.status === false ||
      response?.payload === undefined
    ) {
      let error_msg = "";
      if (response?.payload === undefined) {
        error_msg = "An error occured while taking action on this account";
      } else if (response?.payload?.errors?.beneficiary_account?.[0]) {
        error_msg = response.payload.errors.beneficiary_account[0];
      } else if (response?.payload?.errors?.bank_account_number?.[0]) {
        error_msg = response.payload.errors.bank_account_number[0];
      } else {
        error_msg = "An unknown error occurred.";
      }
      if (error_msg === "Beneficiary account already approved") {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (
              item.id === (payload?.type === "bene_account_detail_modal")
                ? payload?.bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "approved" : "pending",
              };
            }
            return item;
          },
        );
        SetViewAccountDetails(updatedData);

        if (payload?.type === "bene_account_detail_modal") {
          await dispatch(viewAccountDetail({ id: payload?.bene_account_id }));
        } else {
          await dispatch(viewAccountDetail({ id }));
        }
      } else {
        const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
          (item) => {
            if (
              item.id === (payload?.type === "bene_account_detail_modal")
                ? payload?.bene_account_id
                : id
            ) {
              return {
                ...item,
                approval_status:
                  item.approval_status === "pending" ? "pending" : "",
                error_msg,
              };
            }
            return item;
          },
        );

        SetViewAccountDetails(updatedData);
      }
      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
    } else {
      const updatedData = viewAccountDetailData?.beneficiary_accounts.map(
        (item) => {
          if (
            item.id === (payload?.type === "bene_account_detail_modal")
              ? payload?.bene_account_id
              : id
          ) {
            return {
              ...item,
              approval_status:
                item.approval_status === "pending" ? "approved" : "pending",
            };
          }
          return item;
        },
      );
      SetViewAccountDetails(updatedData);

      if (payload?.type === "bene_account_detail_modal") {
        await dispatch(viewAccountDetail({ id: payload?.bene_account_id }));
      } else {
        await dispatch(viewAccountDetail({ id }));
      }
      const successMessage =
        payload.internalAccount === "internalAccount"
          ? "Internal account approved successfully."
          : "Beneficiary account approved successfully.";
      CommonToast({
        text: successMessage,
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
      if (payload?.type === "bene_account_detail_modal") {
        setTimeout(() => {
          payload?.closeBeneAccountDetailModal();
          window.location.reload();
        }, IntervalConfiguration?.intervalExtraLarger);
      }
      if (pathName) {
        setTimeout(() => {
          navigate(pathName);
        }, IntervalConfiguration?.intervalPopup);
      }

      if (txn_single_appr === "txn_single_approval") {
        setTimeout(() => {
          navigate(IntervalConfiguration?.navigate_back);
        }, IntervalConfiguration?.intervalExtraLarger);
      }
    }
  };

  const handleDeclinedDetials = (id) => {
    setClickedBtn("reject");
    setshowPopupReject(true);
    SetdeniedId(id);
  };

  const handlecloseSchedule = () => {
    setShowPopup(false);
  };
  const handleClosePopup = () => {
    // setRejectTxnPopup(false);
    setShowPopup(false);
    setshowPopupReject(false);
    if (payload?.type !== "bene_account_detail_modal") {
      setPreventMultiEnter(false);
      if (payload?.type === "scheduleAcc") {
        setShowScheduleTxnPopup(false);
      }
    }
    setDeclineReason("");
  };
  const updateAllAccounts = (updatedAccounts) => {
    SetViewAccountDetails(updatedAccounts);
  };

  const handleAccountSelection = (beneAccountId) => {};

  const handleArchiveButton = async () => {
    let thunkAction = achivedAccountDetail;
    UniversalRefreshToast("archive");
    const archived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      archived_response.type !== "achivedAccountDetail/rejected" ||
      archived_response.payload === "Beneficiary account already archived"
    ) {
      await dispatch(viewAccountDetail({ id }));
    }
    handleCloseModal();
    setAchivedOpenPop(false);
  };

  const handleUnArchiveButton = async () => {
    let thunkAction = unachivedAccountDetail;
    UniversalRefreshToast("unarchive");
    const unarchived_response = await dispatch(thunkAction({ id, navigate }));
    if (
      unarchived_response.type !== "unachivedAccountDetail/rejected" ||
      unarchived_response.payload === "Beneficiary account already pending"
    ) {
      await dispatch(viewAccountDetail({ id }));
    }
    handleCloseModal();
  };

  // useEffect

  useEffect(() => {
    fetchData();
    let availableLabels = sessionStorage?.getItem("AvailableLabels");
    const parsedLabels = JSON?.parse(availableLabels);
    setLabels(parsedLabels);
  }, [payload?.bene_account_id, id, dispatch]);

  useEffect(() => {
    if (viewAccountDetailData) {
      SetViewAccountDetails(viewAccountDetailData?.beneficiary_accounts);
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    if (
      viewAccountDetailData &&
      viewAccountDetailData.beneficiary_accounts &&
      viewAccountDetailData.beneficiary_accounts.length >
        GlobalConfiguration?.lengthCheckZero
    ) {
      const { bank_name, bank_acc_no, category, ifsc_code, id, pan_no, name } =
        viewAccountDetailData.beneficiary_accounts[0];
      setCurrentAccountDetails({
        bank_name,
        bank_acc_no,
        category,
        ifsc_code,
        id,
        pan: pan_no,
        bank_account_holder_full_name: name,
        name: name,
      });
    }
  }, [viewAccountDetailData]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= ScreenSizeConfiguration?.mobileScreen);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [window.innerWidth]);

  useEffect(() => {
    let accountData = [];
    if (viewAccountDetailData) {
      accountData = viewAccountDetailData?.beneficiary_accounts[0].logs;
    }
    if (
      accountData &&
      viewAccountDetailData?.beneficiary_accounts[0].archived === "Y"
    ) {
      setNameArchive(
        [...accountData]
          .filter((fil) => {
            if (fil.action === "Archived") {
              return true;
            } else return false;
          })
          .sort((a, b) => new Date(b.timestamp) - new Date(a.timestamp))[0]
          ?.user_full_name,
      );
    }
  }, [ViewAccountDetails]);

  useEffect(() => {
    if (beneLookData || bankData) {
      if (
        beneLookData?.total_count > GlobalConfiguration?.lengthCheckOne ||
        bankData?.total_count > GlobalConfiguration?.lengthCheckOne
      ) {
        setIsDisabled(true);
      }
    }
  }, [beneLookData, bankData]);

  useEffect(() => {
    if (viewAccountDetailData) {
      dispatch(beneLookUp({ pan_number: currentAccountDetails.pan }));
      dispatch(
        beneBankLookUp({
          ifsc: currentAccountDetails.ifsc_code,
          bank_account_no: currentAccountDetails.bank_acc_no,
        }),
      );
    }
  }, [
    currentAccountDetails.pan,
    currentAccountDetails.ifsc_code,
    currentAccountDetails.bank_acc_no,
  ]);

  useEffect(() => {
    sessionStorage.removeItem("PAN GST Edit NewValue");
  }, []);

  const handleRejectScheduleTxn = async () => {
    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length >
        GlobalConfiguration?.lengthCheckZero
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > GlobalConfiguration.lengthCheckZero) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";
        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });

        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });
        setShowScheduleTxnPopup(false);

        if (associateschedule !== "AlertSchedule") {
          if (payload.type === "bene_account_detail_modal") {
            handleConfirmDecline(payload?.bene_account_id, declineReason);
          } else {
            handleConfirmDecline(id, declineReason);
          }
        }
        if (payload?.type === "bene_account_detail_modal") {
          await dispatch(viewAccountDetail({ id: payload?.bene_account_id }));
        } else {
          await dispatch(viewAccountDetail({ id }));
        }
      }
      setDeclineReason("");
      setshowPopupReject(false);
    }
  };

  const getErrorMessage = (res) => {
    const p =
      res?.payload.response.data.ids?.unsuccessful_ids[0].errors ||
      res?.payload;
    const e = res?.error;
    if (typeof p === "string") return p;
    if (p?.message) return p.message;
    if (p?.errors?.base?.[0]) {
      const base = p.errors.base[0];
      return typeof base === "string"
        ? base
        : base?.errors?.[0] || base?.message || "Something went wrong";
    }
    if (e?.message) return e.message;
    return "Something went wrong";
  };

  const handleAssignLabelsProp = async (labelsToAssign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array?.isArray(value) ? value : [value]);
    const res = await dispatch(
      addNewLabel({
        record_ids: toArray(id),
        labels: labelsToAssign,
      }),
    );
    if (addNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();

      CommonToast({
        text: "Labels assigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (addNewLabel.rejected.match(res)) {
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelLoading(false);
  };

  const handleUnassignLabelsProp = async (labelsToUnassign) => {
    setLabelLoading(true);

    const toArray = (value) => (Array.isArray(value) ? value : [value]);

    const res = await dispatch(
      removeNewLabel({
        record_ids: toArray(id),
        labels: labelsToUnassign,
      }),
    );

    if (removeNewLabel.fulfilled.match(res)) {
      fetchData();
      toast.dismiss();

      CommonToast({
        text: "Labels unassigned successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    if (removeNewLabel.rejected.match(res)) {
      toast.dismiss();
      CommonToast({
        text: getErrorMessage(res),
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--error)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });
    }
    setLabelLoading(false);
    if (removeNewLabel?.fulfilled?.match(res)) {
      return true;
    } else {
      return false;
    }
  };
  const [isFocused, setIsFocused] = useState(false);
  const computeVariant = (value, focused) => {
    const length = (value ?? "").trim().length;

    if (length === 0) return "default";

    if (length >= GlobalConfiguration.rejectReasonMinLength) {
      return "verified";
    }

    return focused ? "typing" : "error";
  };

  return (
    <>
      {showAdditionalSection && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <AdditionalRecipient
            finalRecipients={finalRecipients}
            setShowAdditionalSection={setShowAdditionalSection}
            accountID={id}
            showAdditionalRecipient={showAdditionalRecipient}
            setShowAdditionalRecipient={setShowAdditionalRecipient}
            handleConfirm={handleConfirm}
            recipients={recipients}
            setRecipients={setRecipients}
            buttonDisabled={recipientButtonDisabled}
            setButtonDisabled={setRecipientButtonDisabled}
            additionalChip={additionalChip}
            setAdditionalChip={setAdditionalChip}
          />
        </div>
      )}
      {showGstPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: { gstnumber: ViewAccountDetails?.[0]?.gstin_detail },
            })
          }
          closeiconhandleFunction={() => setGstShowPopup(false)}
        >
          <GSTVerification
            gst_number={ViewAccountDetails?.[0]?.gstin_detail}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      {showIfscPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="IFSC Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(
                `/settings/IFSC_verification/IFSC_Details/${ViewAccountDetails?.[0]?.ifsc_code}`,
              )
            }
            closeiconhandleFunction={() => setIfscShowPopup(false)}
          >
            <OwnerAccountIFSC
              ifsc_code={ViewAccountDetails?.[0]?.ifsc_code}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}
      {showPanPopup && (
        <div>
          <LargePopupRedirect
            headerTitle="PAN Details"
            isfullViewrequired={true}
            fullviewhandleFunction={() =>
              navigate(`/settings/PAN_verification`, {
                state: ViewAccountDetails?.[0]?.pan_no,
              })
            }
            closeiconhandleFunction={() => setPanShowPopup(false)}
          >
            <PanVerification
              pan_no={ViewAccountDetails?.[0]?.pan_no}
              popup={true}
            />
          </LargePopupRedirect>
        </div>
      )}

      {alertPopUp && (
        <div className="fixed top-top-base left-left-base w-full h-full flex items-center bg-Primary-black justify-center z-z-index-max bg-dark-opacity">
          <FullScreen
            id={payload?.bene_account_id}
            setAlertPopUp={setAlertPopUp}
          />
        </div>
      )}

      {isEditModalOpen && (
        <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-opacity-dark-opacity">
          <EditCommonPopup
            btnOneHandleFunction={handleModalClose}
            headerTitle="Select the option you would like to edit:"
            alertBackground="emphasis"
            chipsArray={chipsArray}
            btnOneText="Cancel"
            btnOneEnabledBgColor="var(--primary-bg)"
            btnOneEnabledTextColor="var(--text-primary)"
            btnOneHoverOption="white"
            btnOneOutLineColor="var(--text-primary)"
            btnTwoText="Edit"
            btnTwoHandleFunction={handleApply}
            btnTwoIsDisabled={
              selectedChipIndex === null ||
              selectedChipIndex === GlobalConfiguration.lengthCheckZero
            }
            btnTwoInActiveVariantNeeded
            btnTwoDisabledTextColor="var(--text-primary)"
            btnTwoEnabledBgColor="var(--text-primary)"
            btnTwoEnabledTextColor="var(--primary-bg)"
            // btnTwoIsLoaderNeeded={handleLoading}
            btnTwoDisabledBgColor="var(--text-disabled)"
            btnTwoHoverOption="black"
          />
        </div>
      )}
      <div
        id="webviewdetailPage"
        className={`${payload.type === "bene_account_detail_modal" ? " h-full" : ""}`}
      >
        <div
          className={`main-div flex flex-col ${payload.type === "bene_account_detail_modal" ? " h-full" : "h-screen"}  ${
            achivedOpenPop || isEditModalOpen
              ? "overflow-hidden"
              : payload.type === "bene_account_detail_modal"
                ? " overflow-x-hidden"
                : "overflow-y-auto overflow-x-hidden"
          }`}
        >
          {showRejectTnxPopup && (
            <div className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-dark-opacity">
              <div ref={popupRef}>
                <LargePopupRedirect
                  headerTitle="Associated transactions found"
                  headersubtext="The following transactions are linked and need to be rejected before rejecting this account."
                  closeiconenabledBgColor="var(--primary-nav)"
                  closeiconisLoading={false}
                  closeiconhandleFunction={() => {
                    setRejectTxnPopup(false);
                    setDeclineReason("");
                    setassociatePending("");
                  }}
                  closeicon={ICONS?.CLOSE}
                  closeiconhoverOption="white"
                  closeiconbtnType={"button"}
                  closeiconisDisabled={false}
                  closeicondisabledBgColor={""}
                  closeiconbuttonRef={null}
                  closeicontitle={"Close"}
                  btnType={"button"}
                  bottomHeaderTextNeed={true}
                  bottomHeaderText={
                    "To reject the account, please reject the transactions listed above by clicking the “Reject all” button. The transactions will get rejected with the provided rejected reason."
                  }
                  isbottomSectionneed={true}
                  btnText={"Reject all"}
                  hoverOption="black"
                  confirmbtnrequired={true}
                  handleFunction={() => {
                    if (associatePending === "AlertPendingTxn") {
                      handleAccRejectAlert();
                    } else {
                      handleRejectAllTransaction();
                    }
                  }}
                  enabledBgColor={"var(--negative-act)"}
                  outLineColor={""}
                  enabledTextColor={"var(--text-primary)"}
                  fullWidthRequired={false}
                  inActiveVariantNeeded
                  isDisabled={
                    services?.find(
                      (service) => service === "ABeneficiaryTxn",
                    ) === undefined
                  }
                  disabledTextColor={"var(--text-primary)"}
                  disabledBgColor={"var(--text-disabled)"}
                >
                  {showRejectTnxPopup && (
                    <>
                      {" "}
                      <BeneficiaryTransactionViewall
                        bene_account_id={id || payload?.bene_account_id}
                        typepop={"BeneAccRejectTxn"}
                        flowType={
                          payload?.type === "scheduleAcc"
                            ? "scheduleAcc"
                            : associatePending === "AlertPendingTxn"
                              ? "AlertPendingTxn"
                              : "decline account details"
                        }
                        closeRejectAllTxn={handleClosePopup}
                        bene_account_name={
                          viewAccountDetailData?.beneficiary_accounts[0]?.name
                        }
                        handleRejectAllTransaction={
                          associatePending === "AlertPendingTxn"
                            ? handleAccRejectAlert
                            : handleRejectAllTransaction
                        }
                        type={payload?.type || "bene_account_detail_modal"}
                        setShowLoader={setShowLoader}
                        setSidebarState={(e) => {}}
                        setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                        showLoader={showLoader}
                        setFocus={(e) => {}}
                      />
                    </>
                  )}
                </LargePopupRedirect>
              </div>
            </div>
          )}
          {showScheduleTxnPopup && (
            <div
              className="fixed top-top-base left-left-base w-screen h-screen flex items-center justify-center z-z-index-modal bg-PopUp-BackDrop bg-dark-opacity"
              ref={popupRef}
            >
              <LargePopupRedirect
                headerTitle="Associated schedules found"
                headersubtext="The following schedules are linked and need to be rejected before rejecting this account."
                closeiconenabledBgColor="var(--primary-nav)"
                closeiconisLoading={false}
                closeiconhandleFunction={() => {
                  setShowScheduleTxnPopup(false);
                  setDeclineReason("");
                  setassociateschedule("");
                }}
                closeicon={ICONS?.CLOSE}
                closeiconhoverOption="white"
                closeiconbtnType={"button"}
                closeiconisDisabled={false}
                closeicondisabledBgColor={""}
                closeiconbuttonRef={null}
                closeicontitle={"Close"}
                btnType={"button"}
                bottomHeaderTextNeed={true}
                bottomHeaderText={
                  "To reject the account, please reject the schedules listed above by clicking the “Reject all” button. The schedules will get rejected with the provided rejected reason."
                }
                isbottomSectionneed={true}
                btnText={"Reject all"}
                confirmbtnrequired={true}
                handleFunction={() => {
                  if (associateschedule === "AlertSchedule") {
                    handleAlertSchedule();
                  } else {
                    handleRejectScheduleTxn();
                  }
                }}
                enabledBgColor={"var(--negative-act)"}
                hoverOption={"black"}
                outLineColor={""}
                enabledTextColor={"var(--text-primary)"}
                fullWidthRequired={false}
                inActiveVariantNeeded
                isDisabled={
                  services?.find((service) => service === "BAScheduledTxn") ===
                  undefined
                }
                disabledTextColor={"var(--text-primary)"}
                disabledBgColor={"var(--text-disabled"}
              >
                <ScheduleBeneficiaryTransactionViewSchedules
                  type={"ScheduleAccBeneAcc"}
                  payload={{
                    schedule_acc_id: id || payload?.bene_account_id,
                    number: "swadfsafs",

                    schedule_acc_name:
                      viewAccountDetailData?.beneficiary_accounts[0]?.name,
                    handleRejectAllTransaction:
                      associateschedule === "AlertSchedule"
                        ? handleAlertSchedule
                        : handleRejectScheduleTxn,
                  }}
                  closeCallback={handleClosePopup}
                />
              </LargePopupRedirect>
            </div>
          )}
          {loading ? (
            <div className="loader-container m-auto justify-center items-center flex">
              <Loader />
            </div>
          ) : (
            <>
              <div
                className={`bene_detail_heder_containerm  ${payload?.type === "bene_account_detail_modal" && "hidden"} Qmd:hidden`}
              >
                <TopNavComponent
                  isFormattingNotRequired={true}
                  topNavHeader={"Beneficiary"}
                  topNavSubText="Account details"
                />
              </div>
              <div
                className={` h-auto Qmd:bg-primary-nav bg-primary-card ${
                  payload?.type === "bene_account_detail_modal"
                    ? null
                    : "main-alignment "
                }`}
              >
                {showPopup && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                    <DeclinedPopup
                      type={
                        payload?.internalAccount === "internalAccount"
                          ? "internalAccount"
                          : payload?.type === "scheduleAcc"
                            ? "scheduleAcc"
                            : "decline account details"
                      }
                      onClose={handleClosePopup}
                      handlecloseSchedule={handlecloseSchedule}
                      accountId={deniedId}
                      beneid={id}
                      associateschedule={associateschedule}
                      associatePending={associatePending}
                      id={
                        payload?.type === "bene_account_detail_modal"
                          ? payload?.bene_account_id
                          : id
                      }
                      accountName={
                        viewAccountDetailData?.beneficiary_accounts[0]?.name
                      }
                      allAccounts={ViewAccountDetails}
                      updateAllAccounts={updateAllAccounts}
                      showRejectTnxPopup={showRejectTnxPopup}
                      setRejectTxnPopup={setRejectTxnPopup}
                      preventMultiEnter={preventMultiEnter}
                      setPreventMultiEnter={setPreventMultiEnter}
                      modaltype={
                        payload?.type === "bene_account_detail_modal"
                          ? "bene_account_detail_modal"
                          : ""
                      }
                      closeBeneAccountDetailModal={
                        payload?.closeBeneAccountDetailModal
                      }
                      txn_single_appr={txn_single_appr}
                      showScheduleTxnPopup={showScheduleTxnPopup}
                      setShowScheduleTxnPopup={setShowScheduleTxnPopup}
                    />
                  </div>
                )}

                {showPopupReject && (
                  <div className="fixed top-top-base left-left-base w-full h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-z-index-modal">
                    <SmallPopupWithInput
                      headerTitle="Rejected reason"
                      headerFontWeight="semibold"
                      headerFontColor="text-primary"
                      textSize="font-md"
                      secondHeaderTitle="Please state the reason for rejecting the account."
                      secondHeaderFontWeight="normal"
                      secondHeaderFontColor="text-secondary"
                      secondHeaderTextSize="font-xs"
                      noteColor="text-secondary"
                      inputPlaceholder="Reason (10-150 char)"
                      inputVariant={computeVariant(declineReason, isFocused)}
                      inputOnFocus={(e) => setIsFocused(true)}
                      inputOnBlur={(e) => setIsFocused(false)}
                      inputIsDisabled={showLoader ? true : false}
                      btnOneIsDisabled={showLoader ? true : false}
                      inputBgColor="var(--primary-bg)"
                      inputFgColor="var(--text-secondary)"
                      inputOnInput={(e) => {
                        if (!showLoader) {
                          handleInputChange(e);
                        }
                      }}
                      inputValue={declineReason}
                      inputFontKind="small"
                      inputIsFullWidth={true}
                      btnOneText="Cancel"
                      btnOneHandleFunction={() => {
                        if (!showLoader) {
                          handleClosePopup();
                        }
                      }}
                      btnOneEnabledBgColor="var(--primary-bg)"
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneHoverOption="white"
                      btnTwoText="Reject"
                      btnTwoHandleFunction={() => {
                        if (associatePending === "AlertPendingTxn") {
                          handleRejectAlert();
                        } else if (associateschedule === "AlertSchedule") {
                          handleRejectScheduleTxn();
                        } else {
                          handleRejectTransactionChecker(
                            deniedId,
                            declineReason,
                          );
                        }
                      }}
                      btnTwoEnabledBgColor="var(--negative-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={
                        !declineReason ||
                        declineReason.length < GlobalConfiguration?.panLength
                      }
                      btnTwoDisabledBgColor="var(--text-disabled)"
                      btnTwoIsLoaderNeeded={showLoader ? true : false}
                      btnTwoIsLoading={showLoader ? true : false}
                      btnTwoHoverOption="black"
                      btnTwoInActiveVariantNeeded={true}
                    />
                  </div>
                )}

                {openBeneAssociate && (
                  <BeneAccountViewAllPopup
                    id={currentAccountDetails.id}
                    type={payload?.type}
                    onClose={handleCloseModal}
                    onAccountSelect={handleAccountSelection}
                    associateAccount={true}
                    associatepanNumber={currentAccountDetails.pan}
                    associateIFSC={currentAccountDetails.ifsc_code}
                    associateaccountNumber={currentAccountDetails.bank_acc_no}
                    setOpenBeneAssociate={setOpenBeneAssociate}
                    beneAccountId={currentAccountDetails.id}
                    accountType={accountType}
                    flow={"beneTxn"}
                    ispanbankRequired={true}
                    activeType={activeType}
                    setActiveType={setActiveType}
                    setRemPan={setRemPan}
                    setRemAccount={setRemAccount}
                    setRemIFSC={setRemIFSC}
                    remPan={remPan}
                    remAccount={remAccount}
                    remIFSC={remIFSC}
                    typePanBank={"BeneAccPanBankSwitch"}
                    handleClick={handleClick}
                    setAlertPopUp={setAlertPopUp}
                  />
                )}
                {unachivedOpenPop && (
                  <div
                    onClick={() => setUnachivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <SmallPopup
                      headerTitle={
                        "Are you sure you want to unarchive this account?"
                      }
                      subtext="Unarchiving this account will make it active again and set its status to pending."
                      btnOneText="Cancel"
                      btnOneBtnType="button"
                      btnOneEnabledBgColor="transparent"
                      btnOneHandleFunction={handleCloseModal}
                      btnOneOutLineColor="var(--text-primary)"
                      btnOneEnabledTextColor="var(--text-primary)"
                      btnOneIsDisabled={false}
                      btnOneHoverOption="white"
                      btnTwoText="Unarchive"
                      btnTwoBtnType="button"
                      btnTwoHandleFunction={handleUnArchiveButton}
                      btnTwoEnabledBgColor="var(--positive-act)"
                      btnTwoEnabledTextColor="var(--text-primary)"
                      btnTwoIsDisabled={false}
                      btnTwoHoverOption="black"
                    />
                  </div>
                )}
                {achivedOpenPop && (
                  <div
                    onClick={() => setAchivedOpenPop(false)}
                    className="fixed top-top-base left-left-base w-width-full h-height-full flex items-center bg-PopUp-BackDrop justify-center z-z-index-modal bg-opacity-dark-opacity"
                  >
                    <div>
                      <SmallPopup
                        headerTitle={
                          "Are you sure you want to archive this account?"
                        }
                        headerFontWeight="semibold"
                        headerFontColor="text-primary"
                        textSize="font-md"
                        subtext="Archiving this account will make it inactive and cannot be used unless unarchived."
                        btnOneText="Cancel"
                        btnOneBtnType="button"
                        btnOneEnabledBgColor="transparent"
                        btnOneHandleFunction={handleCloseModal}
                        btnOneOutLineColor="var(--text-primary)"
                        btnOneEnabledTextColor="var(--text-primary)"
                        btnOneIsDisabled={false}
                        btnOneHoverOption="white"
                        btnTwoText="Archive"
                        btnTwoBtnType="button"
                        btnTwoHandleFunction={handleArchiveButton}
                        btnTwoEnabledBgColor="var(--negative-act)"
                        btnTwoEnabledTextColor="var(--text-primary)"
                        btnTwoIsDisabled={false}
                        btnTwoHoverOption="black"
                      />
                    </div>
                  </div>
                )}

                {openTransHistory && (
                  <LargePopupRedirect
                    headerTitle={"Transaction history"}
                    headersubtext={
                      "All transactions related to the beneficiary are listed below."
                    }
                    closeiconenabledBgColor="var(--primary-nav)"
                    closeiconisLoading={false}
                    closeiconhandleFunction={() => closeTransactionHistory()}
                    closeicon={ICONS?.CLOSE}
                    closeiconhoverOption="white"
                    closeiconbtnType={"button"}
                    closeiconisDisabled={false}
                    closeicondisabledBgColor={""}
                    closeiconbuttonRef={null}
                    closeicontitle={"Close"}
                    btnType={"button"}
                    enabledBgColor={"var(--negative-act)"}
                    hoverOption={"dark"}
                    outLineColor={""}
                    enabledTextColor={"var(--text-primary)"}
                    fullWidthRequired={false}
                    isDisabled={false}
                    disabledTextColor={""}
                    disabledBgColor={""}
                  >
                    <BeneficiaryTransactionViewall
                      bene_account_name={
                        viewAccountDetailData?.beneficiary_accounts[0]?.name
                      }
                      bene_account_id={
                        viewAccountDetailData?.beneficiary_accounts[0]?.id
                      }
                      bene_account_confidential={null}
                      onClose={closeTransactionHistory}
                      typepop={"txnHistorypopup"}
                    />
                  </LargePopupRedirect>
                )}
                {showLabelsPopup && (
                  <div className="fixed left-left-base w-full top-top-base h-full bg-PopUp-BackDrop bg-opacity-dark-opacity flex items-center justify-center z-max-zindex">
                    <CommonAssignLabelPopup
                      headerTitle="Assign/unassign labels:"
                      headersubtext="Labels will be used to generate statistics for the associated accounts."
                      closehandleFunction={handleClose}
                      closeisDisabled={false}
                      labels={labels}
                      setLabels={setLabels}
                      LabelAccounts={id}
                      isLabelPopupOpen={showLabelsPopup}
                      filteredData={viewAccountDetailData?.beneficiary_accounts}
                      onClose={handleClose}
                      loading={labelLoading}
                      setLoading={setLabelLoading}
                      handleAssignLabels={handleAssignLabelsProp}
                      handleUnassignLabels={handleUnassignLabelsProp}
                    />
                  </div>
                )}
                <div
                  className={`w-full max-w-screen-Qlg m-auto Qmd:bg-primary-nav bg-primary-card ${payload?.type === "bene_account_detail_modal" ? "" : "Qmd:mt-margin-sm"}  `}
                  id="container"
                >
                  <div className="flex w-full bg-primary-nav  m-auto h-height-sm  Qlg:px-padding-base">
                    <div
                      className={`bene-account-primary-details  ${
                        payload?.type === "bene_account_detail_modal"
                          ? ""
                          : "mt-margin-base Qmd:mt-margin-lg"
                      }`}
                    >
                      {viewAccountDetailData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="flex border-b border-solid border-primary-bg justify-between  mx-margin-md Qmd:mx-margin-base "
                          >
                            <div className="flex flex-col Qmd:flex-row w-full ">
                              <div className="py-padding-md w-full Qmd:w-right-half border-b Qmd:border-b-border-base border-solid border-primary-bg">
                                <div className="flex flex-col Qmd:border-r border-solid border-primary-bg Qmd:pl-padding-sm">
                                  <TitleSubtitlePair
                                    title={accountNameStandardised(
                                      account.name.trim(),
                                    )}
                                    titleColor="text-primary "
                                    subtitle={
                                      account?.name?.trim() ===
                                      account?.pan_legal_name?.trim()
                                        ? "Account name - Using legal name"
                                        : "Account name"
                                    }
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>

                              {ViewAccountDetails?.map((account) => (
                                <div
                                  key={account.id}
                                  className="w-full Qmd:w-right-half py-padding-md"
                                >
                                  <div className="flex flex-col items-start  Qmd:pl-padding-md">
                                    <TitleSubtitlePair
                                      title={
                                        account?.approval_status === "error"
                                          ? "Pending"
                                          : account?.approval_status
                                              ?.toLowerCase()
                                              ?.split(" ")
                                              ?.map(
                                                (word) =>
                                                  word
                                                    .charAt(
                                                      GlobalConfiguration?.lengthCheckZero,
                                                    )
                                                    .toUpperCase() +
                                                  word.slice(
                                                    GlobalConfiguration?.lengthCheckOne,
                                                  ),
                                              )
                                              ?.join(" ")
                                      }
                                      titleColor={`${
                                        account.approval_status === "pending" ||
                                        account.approval_status === "error"
                                          ? "pending"
                                          : account.approval_status ===
                                              "approved"
                                            ? "awaiting"
                                            : account.approval_status ===
                                                "rejected"
                                              ? "failed"
                                              : account.approval_status ===
                                                  "blocked"
                                                ? "failed"
                                                : account.approval_status ===
                                                    "archived"
                                                  ? "abandoned"
                                                  : ""
                                      }`}
                                      subtitle="Account status"
                                      alignRight={false}
                                      hoverOption="white"
                                      isBold={false}
                                      variant="md"
                                    />
                                  </div>
                                </div>
                              ))}
                            </div>
                            <div className="associated-account-transaction-history-block Qmd:flex flex-row bg-primary-nav-act hidden">
                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Associated
                                    <br />
                                    accounts
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    payload.type === "bene_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                    return;
                                  }
                                  setRemPan(currentAccountDetails.pan);
                                  openAssociatedAccountsFound();
                                }}
                                icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                isDisabled={
                                  payload.type === "bene_account_detail_modal"
                                }
                                hoverOption="white"
                              />

                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              <TopNavSmallButton
                                btnText={
                                  <>
                                    Transaction <br /> history
                                  </>
                                }
                                handleFunction={() => {
                                  if (
                                    payload.type === "bene_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                    return;
                                  }
                                  openTransactionHistory();
                                }}
                                icon={ICONS?.TRANSACTION_HISTORY}
                                enabledBgColor={"var(--primary-nav-act)"}
                                enabledTextColor={"var(--text-primary)"}
                                disabledBgColor={"var(--primary-nav-act)"}
                                disabledTextColor={"var(--text-primary)"}
                                hoverOption="white"
                                isDisabled={
                                  payload.type === "bene_account_detail_modal"
                                }
                              />
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex border-b border-solid border-primary-bg justify-between mx-margin-md Qmd:mx-margin-base"
                          >
                            <div className="flex flex-col Qmd:flex-row w-full ">
                              <div className="py-padding-md Qmd:pl-padding-sm flex flex-col w-full Qmd:w-right-half Qmd:border-b-border-base border-b border-solid border-primary-bg">
                                <TitleSubtitlePair
                                  title={formatAccountNumber(
                                    account.bank_acc_no,
                                  )}
                                  titleColor="text-primary"
                                  subtitle="  Account number"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                />
                              </div>
                              <div className="py-padding-md w-full Qmd:w-right-half">
                                <div className="flex flex-col items-start  Qmd:pl-padding-md Qmd:border-l border-l-border-base border-solid border-primary-bg">
                                  <TitleSubtitlePair
                                    title={account.bank_account_holder_full_name
                                      ?.toLowerCase()
                                      ?.split(" ")
                                      ?.map(
                                        (word) =>
                                          word
                                            .charAt(
                                              GlobalConfiguration?.lengthCheckZero,
                                            )
                                            .toUpperCase() +
                                          word.slice(
                                            GlobalConfiguration?.lengthCheckOne,
                                          ),
                                      )
                                      ?.join(" ")}
                                    titleColor="text-primary"
                                    subtitle=" Bank account holder name"
                                    alignRight={false}
                                    hoverOption="white"
                                    isBold={false}
                                    variant="md"
                                  />
                                </div>
                              </div>
                            </div>
                            <div className="settings Qmd:flex flex-row hidden justify-end bg-primary-nav-act">
                              {services?.find(
                                (service) =>
                                  service === "BUAccount" ||
                                  service === "Admin",
                              ) === undefined ||
                              viewAccountDetailData?.beneficiary_accounts[0]
                                .approval_status === "archived" ||
                              viewAccountDetailData?.beneficiary_accounts[0]
                                .approval_status === "blocked" ? (
                                <>
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        {" "}
                                        Edit <br /> account
                                      </>
                                    }
                                    handleFunction={() => {
                                      if (
                                        viewAccountDetailData
                                          ?.beneficiary_accounts[0]
                                          .approval_status !== "archived" &&
                                        viewAccountDetailData
                                          ?.beneficiary_accounts[0]
                                          .approval_status !== "blocked"
                                      ) {
                                        if (
                                          services?.find(
                                            (service) =>
                                              service === "BUAccount" ||
                                              (service === "Admin" &&
                                                payload?.servicesType !==
                                                  "BenAdmin"),
                                          ) !== undefined
                                        ) {
                                          handleModalOpen(id);
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "BUAccount",
                                            },
                                          });
                                        }
                                      }
                                    }}
                                    icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    hoverOption="white"
                                    isDisabled={
                                      payload.type ===
                                        "bene_account_detail_modal" ||
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        ?.approval_status === "archived" ||
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        ?.approval_status === "blocked" ||
                                      services?.find(
                                        (service) =>
                                          service === "BUAccount" ||
                                          (service === "Admin" &&
                                            payload?.servicesType !==
                                              "BenAdmin"),
                                      ) === undefined
                                    }
                                  />
                                </>
                              ) : (
                                <>
                                  <TopNavSmallButton
                                    btnText={
                                      <>
                                        {" "}
                                        Edit <br /> account
                                      </>
                                    }
                                    handleFunction={() => {
                                      if (
                                        payload?.type !==
                                        "bene_account_detail_modal"
                                      ) {
                                        if (
                                          services?.find(
                                            (service) =>
                                              service === "BUAccount" ||
                                              service === "Admin",
                                          ) !== undefined
                                        ) {
                                          handleModalOpen(id);
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService: "BUAccount",
                                            },
                                          });
                                        }
                                      } else if (
                                        payload.type ===
                                        "bene_account_detail_modal"
                                      ) {
                                        actionRestricted();
                                      }
                                    }}
                                    icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                                    enabledTextColor="var(--text-primary)"
                                    enabledBgColor="var(--primary-nav-act)"
                                    disabledBgColor="var(--primary-nav-act)"
                                    hoverOption="white"
                                    isDisabled={
                                      payload.type ===
                                        "bene_account_detail_modal" ||
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        ?.approval_status === "archived" ||
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        ?.approval_status === "blocked" ||
                                      services?.find(
                                        (service) =>
                                          service === "BUAccount" ||
                                          (service === "Admin" &&
                                            payload?.servicesType !==
                                              "BenAdmin"),
                                      ) === undefined
                                    }
                                  />
                                </>
                              )}
                              <div className="py-padding-button-l flex">
                                <div className="flex-grow border-r border-solid border-primary-bg"></div>
                              </div>

                              {viewAccountDetailData?.beneficiary_accounts[0]
                                .approval_status === "blocked" ||
                              services?.find(
                                (service) =>
                                  service === "BAAccountArchive" ||
                                  service === "Admin",
                              ) === undefined ? (
                                <>
                                  <TopNavSmallButton
                                    btnText={label}
                                    handleFunction={() => {
                                      if (
                                        viewAccountDetailData
                                          ?.beneficiary_accounts[0]
                                          .approval_status !== "blocked"
                                      ) {
                                        if (
                                          services?.find(
                                            (service) =>
                                              service === "BAAccountArchive" ||
                                              service === "Admin",
                                          ) !== undefined
                                        ) {
                                          handleUnarchive();
                                          handleArchive();
                                        } else {
                                          navigate("/feature_not_assigned", {
                                            state: {
                                              unavailableService:
                                                "BAAccountArchive",
                                            },
                                          });
                                        }
                                      }
                                    }}
                                    icon={
                                      services?.find(
                                        (service) =>
                                          service === "BAAccountArchive" ||
                                          service === "Admin",
                                      ) === undefined &&
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        .approval_status === "archived"
                                        ? ICONS?.UNARCHIVE
                                        : ICONS?.ARCHIVE
                                    }
                                    enabledBgColor={"var(--primary-nav-act)"}
                                    enabledTextColor={"var(--text-primary)"}
                                    hoverOption="white"
                                    isDisabled={
                                      payload.type ===
                                        "bene_account_detail_modal" ||
                                      viewAccountDetailData
                                        ?.beneficiary_accounts[0]
                                        .approval_status === "blocked"
                                    }
                                  />
                                </>
                              ) : (
                                <TopNavSmallButton
                                  btnText={
                                    viewAccountDetailData
                                      ?.beneficiary_accounts[0]
                                      .approval_status === "archived" ? (
                                      <>
                                        Unarchive <br /> account{" "}
                                      </>
                                    ) : (
                                      <>
                                        Archive <br /> account{" "}
                                      </>
                                    )
                                  }
                                  handleFunction={() => {
                                    if (
                                      payload?.type !==
                                      "bene_account_detail_modal"
                                    ) {
                                      if (
                                        services?.find(
                                          (service) =>
                                            service === "BAAccountArchive" ||
                                            service === "Admin",
                                        ) !== undefined
                                      ) {
                                        handleUnarchive();
                                        handleArchive();
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService:
                                              "BAAccountArchive",
                                          },
                                        });
                                      }
                                    } else if (
                                      payload.type ===
                                      "bene_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    }
                                  }}
                                  icon={
                                    viewAccountDetailData
                                      ?.beneficiary_accounts[0]
                                      .approval_status === "archived"
                                      ? ICONS?.ARCHIVE
                                      : ICONS?.UNARCHIVE
                                  }
                                  enabledBgColor={"var(--primary-nav-act)"}
                                  enabledTextColor={"var(--text-primary"}
                                  hoverOption="white"
                                  isDisabled={
                                    payload.type === "bene_account_detail_modal"
                                  }
                                />
                              )}
                            </div>
                          </div>
                        ),
                      )}
                      {viewAccountDetailData?.beneficiary_accounts.map(
                        (account) => (
                          <div
                            key={account.id}
                            className="bene-account-holder-details flex justify-between items-center flex-col Qmd:flex-row "
                          >
                            <div className="flex Qmd:flex-row  w-full ">
                              <div
                                className={`flex justify-between items-center w-full  Qsmd:w-right-half my-margin-sm Qmd:my-margin-base mr-margin-md ml-margin-sm  Qmd:mx-margin-base  ${account?.approval_status === "pending" || account?.approval_status === "approved" ? "" : "Qmd:pt-padding-sm Qmd:pb-padding-md"}`}
                              >
                                <TitleSubtitlePair
                                  title={account?.ifsc_code}
                                  titleColor="text-primary "
                                  isDisabled={
                                    payload.type === "bene_account_detail_modal"
                                      ? true
                                      : false
                                  }
                                  subtitle="IFSC code"
                                  alignRight={false}
                                  hoverOption="white"
                                  isBold={false}
                                  variant="md"
                                  showArrow="true"
                                  onClick={() => {
                                    if (
                                      services?.find(
                                        (service) =>
                                          service === "VIFSC" ||
                                          service === "Admin",
                                      ) !== undefined &&
                                      account.ifsc_code
                                    ) {
                                      if (
                                        payload.type ===
                                        "bene_account_detail_modal"
                                      ) {
                                        actionRestricted();
                                      } else {
                                        setIfscShowPopup(true);
                                      }
                                    } else {
                                      navigate("/feature_not_assigned", {
                                        state: {
                                          unavailableService: "VIFSC",
                                        },
                                      });
                                    }
                                  }}
                                />

                                <div className="h-[max-content] flex justify-center items-center bg-text-primary rounded-border-radius-md">
                                  <CommonBankLogo
                                    ifsc={account?.ifsc_code}
                                    variant="big"
                                    type="pill"
                                  />
                                </div>
                              </div>

                              <div
                                className={`py-padding-md hidden lg:w-width-md Qsmd:w-width-sm-1-3 Qlg:flex justify-between ${
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected" ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration.lengthCheckZero)
                                    ? "denied-ifsc-div"
                                    : ""
                                }`}
                              >
                                <div
                                  className={`account-ifsc-div-main  flex flex-row pl-padding-sm Qmd:pl-padding-md w-full `}
                                ></div>
                              </div>
                            </div>
                            <div
                              className={`flex w-full Qmd:w-width-sm-1-3  Qmd:h-auto ${
                                (ViewAccountDetails[0]?.approval_status ===
                                  "blocked" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0]?.approval_status ===
                                    "rejected") &&
                                "hidden"
                              }`}
                            >
                              <div
                                className={`${
                                  viewAccountDetailData?.beneficiary_accounts[0]
                                    ?.approval_status === "approved"
                                    ? "w-auto flex-grow bg-primary-nav hidden Qmd:block"
                                    : (ViewAccountDetails[0]
                                          ?.approval_status === "rejected" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero) ||
                                        (ViewAccountDetails[0]
                                          ?.approval_status === "pending" &&
                                          ViewAccountDetails[0]?.error_msg
                                            ?.length >
                                            GlobalConfiguration?.lengthCheckZero)
                                      ? "hidden"
                                      : "w-width-sm-1-3 bg-primary-nav hidden Qmd:block"
                                }`}
                              ></div>

                              <div
                                className={`${
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "rejected" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero) ||
                                  (ViewAccountDetails[0]?.approval_status ===
                                    "pending" &&
                                    ViewAccountDetails[0]?.error_msg?.length >
                                      GlobalConfiguration?.lengthCheckZero)
                                    ? "denied-btn-div"
                                    : "w-full "
                                }`}
                              >
                                <div
                                  className={`${
                                    services?.find(
                                      (service) =>
                                        service === "CBeneficiaryTxn" ||
                                        service === "Admin",
                                    ) === undefined &&
                                    viewAccountDetailData
                                      ?.beneficiary_accounts[0]
                                      .approval_status === "approved"
                                      ? "opacity-light-opacity cursor-not-allowed"
                                      : ""
                                  } pay-bene w-full flex justify-end`}
                                >
                                  {ViewAccountDetails?.map((account) => (
                                    <>
                                      {showLoader ? (
                                        <>
                                          <div className="Qlg:w-max-button-width-for-approval-animation w-full flex">
                                            <div
                                              className={`w-width-full   flex justify-center items-center ${
                                                clickedBtn === "reject"
                                                  ? "bg-negative-act"
                                                  : "bg-positive-act"
                                              } py-padding-lg`}
                                            >
                                              <Loader
                                                height="var(--icon-lg)"
                                                width="var(--icon-lg)"
                                              />
                                            </div>
                                          </div>
                                        </>
                                      ) : account?.approval_status ===
                                        "approved" ? (
                                        <>
                                          <TopNavLargeButton
                                            hoverOption={"black"}
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service ===
                                                    "CBeneficiaryTxn" ||
                                                  service === "Admin",
                                              )
                                            }
                                            btnText={
                                              payload.internalAccount ===
                                              "internalAccount"
                                                ? "Initiate internal transaction"
                                                : "Pay Beneficiary"
                                            }
                                            btnType={"button"}
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service ===
                                                      "CBeneficiaryTxn" ||
                                                    service === "Admin",
                                                ) !== undefined &&
                                                account?.approval_status ===
                                                  "approved"
                                              ) {
                                                createTransaction();
                                                sessionStorage.removeItem(
                                                  "recreate_ben",
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "CBeneficiaryTxn",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={transactionImage}
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary)"
                                            }
                                            fullWidthRequired={isMobile}
                                          />
                                        </>
                                      ) : account?.approval_status ===
                                          "rejected" &&
                                        account?.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`pay-bene-box2 flex justify-end  ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row gap-x-gap-sm h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center">
                                              <img
                                                src={
                                                  ICONS?.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-y-gap-xs w-width-lg">
                                              <span className="font-semibold font-sans text-xs text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-font-xxs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                          "pending" &&
                                        account.error_msg?.length >
                                          GlobalConfiguration?.lengthCheckZero ? (
                                        <div
                                          key={account.id}
                                          className={`pay-bene-box2 flex justify-end Qlg:w-[unset] w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <div className="flex flex-row h-full w-full bg-negative-card p-padding-sm">
                                            <div className="flex place-items-center Qlg:w-1/6">
                                              <img
                                                src={
                                                  ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                                }
                                                className="w-icon-lg h-icon-lg mr-margin-button-m"
                                                alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                              />
                                            </div>
                                            <div className="flex flex-col justify-center gap-gap-xs w-5/6 ml-margin-sm">
                                              <span className="font-semibold font-sans text-sm text-text-primary">
                                                Failed to take action
                                              </span>

                                              <span className="font-sans text-xs text-text-secondary text-ellipsis overflow-hidden w-full block">
                                                {account?.error_msg}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                        "error" ? (
                                        <div className="flex flex-row h-full bg-negative-card p-padding-sm">
                                          <div className="flex place-items-center w-1/6">
                                            <img
                                              src={
                                                ICONS.ERROR_WITH_WHITE_OUTLINED_CIRCLE
                                              }
                                              className="w-icon-lg h-icon-lg mr-margin-button-m"
                                              alt="ERROR_WITH_WHITE_OUTLINED_CIRCLE"
                                            />
                                          </div>
                                          <div className="flex flex-col justify-center gap-y-gap-xs w-5/6">
                                            <span className="font-semibold font-sans text-sm text-text-primary">
                                              Failed to take action
                                            </span>
                                            <div>
                                              <p className="line-clamp-3 whitespace-wrap overflow-ellipsis text-font-xs text-text-primary opacity-base-opacity">
                                                {account?.error_msg
                                                  ? account?.error_msg
                                                  : beneDeniedApprovalData
                                                      ?.errors
                                                      ?.beneficiary_account?.[0]}
                                                .
                                              </p>
                                            </div>
                                          </div>
                                        </div>
                                      ) : account.approval_status ===
                                        "pending" ? (
                                        <div
                                          key={account.id}
                                          className={`pay-bene-box2 flex justify-end w-full ${
                                            account?.approval_status ===
                                              "approved" &&
                                            services?.find(
                                              (service) =>
                                                service === "CBeneficiaryTxn" ||
                                                service === "Admin",
                                            ) !== undefined &&
                                            currentAccountDetails.category
                                              .length >
                                              GlobalConfiguration?.lengthCheckZero
                                              ? "bg-Button-green hover:opacity-dark-opacity"
                                              : account?.approval_status ===
                                                  "approved"
                                                ? "bg-Button-green"
                                                : ""
                                          }`}
                                        >
                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Reject <br /> account
                                              </>
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "BAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                handleDeclinedDetials(
                                                  account.id ||
                                                    payload?.bene_account_id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "BAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={ICONS?.REJECT_ICON_RED}
                                            enabledBgColor={
                                              "var(--negative-act)"
                                            }
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service === "BAAccount" ||
                                                  service === "Admin",
                                              )
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />

                                          <TopNavSmallButton
                                            btnText={
                                              <>
                                                Approve <br /> account
                                              </>
                                            }
                                            isDisabled={
                                              !services?.find(
                                                (service) =>
                                                  service === "BAAccount" ||
                                                  service === "Admin",
                                              )
                                            }
                                            handleFunction={() => {
                                              if (
                                                services?.find(
                                                  (service) =>
                                                    service === "BAAccount" ||
                                                    service === "Admin",
                                                ) !== undefined
                                              ) {
                                                setClickedBtn("approve");
                                                handleApprovalDetails(
                                                  account.id,
                                                );
                                              } else {
                                                navigate(
                                                  "/feature_not_assigned",
                                                  {
                                                    state: {
                                                      unavailableService:
                                                        "BAAccount",
                                                    },
                                                  },
                                                );
                                              }
                                            }}
                                            icon={
                                              ICONS?.APPROVE_CIRCLE_GREEN_CHECKMARK
                                            }
                                            enabledBgColor={
                                              "var(--positive-act)"
                                            }
                                            enabledTextColor={
                                              "var(--text-primary"
                                            }
                                            hoverOption="black"
                                            fullWidthRequired={isMobile}
                                          />
                                        </div>
                                      ) : null}
                                    </>
                                  ))}
                                </div>
                              </div>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  </div>
                </div>
              </div>

              <div className="bene_quickaction_containerm block Qmd:hidden">
                <div className="text-text-primary pl-padding-sm py-padding-button-l text-font-sm font-semibold bg-primary-card">
                  Quick Actions
                </div>
                <div>
                  <div className="associated-account-transaction-history-block Qmd:hidden flex flex-row border-b border-solid border-primary-bg">
                    <TopNavSmallButton
                      btnText={
                        <>
                          Associated <br /> accounts{" "}
                        </>
                      }
                      handleFunction={() => {
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                        } else if (isDisabled) {
                          openAssociatedAccountsFound();
                        }
                      }}
                      icon={ICONS?.ASSSOCIATED_ACCOUNTS_FOUND}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={payload.type === "bene_account_detail_modal"}
                      fullWidthRequired={true}
                    />

                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>
                    <TopNavSmallButton
                      btnText={
                        <>
                          {" "}
                          Transaction <br /> history
                        </>
                      }
                      handleFunction={() => {
                        if (payload.type === "bene_account_detail_modal") {
                          actionRestricted();
                        } else {
                          openTransactionHistory();
                        }
                      }}
                      icon={ICONS?.TRANSACTION_HISTORY}
                      enabledBgColor={"var(--primary-nav-act)"}
                      enabledTextColor={"var(--text-primary"}
                      hoverOption="white"
                      isDisabled={payload.type === "bene_account_detail_modal"}
                      fullWidthRequired={true}
                    />
                  </div>
                  <div className="settingsm flex flex-row bg-primary-nav-act">
                    {services?.find(
                      (service) =>
                        service === "BUAccount" || service === "Admin",
                    ) === undefined ||
                    viewAccountDetailData?.beneficiary_accounts[0]
                      .approval_status === "archived" ||
                    viewAccountDetailData?.beneficiary_accounts[0]
                      .approval_status === "blocked" ? (
                      <>
                        <TopNavSmallButton
                          btnText={
                            <>
                              {" "}
                              Edit <br /> account
                            </>
                          }
                          handleFunction={() => {
                            if (
                              viewAccountDetailData?.beneficiary_accounts[0]
                                ?.approval_status !== "archived" &&
                              viewAccountDetailData?.beneficiary_accounts[0]
                                ?.approval_status !== "blocked"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "BUAccount" ||
                                    (service === "Admin" &&
                                      payload?.servicesType !== "BenAdmin"),
                                ) !== undefined
                              ) {
                                handleModalOpen(id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "BUAccount",
                                  },
                                });
                              }
                            }
                          }}
                          icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          isDisabled={
                            payload.type === "bene_account_detail_modal" ||
                            viewAccountDetailData?.beneficiary_accounts[0]
                              ?.approval_status === "archived" ||
                            viewAccountDetailData?.beneficiary_accounts[0]
                              ?.approval_status === "blocked" ||
                            services?.find(
                              (service) =>
                                service === "BUAccount" ||
                                (service === "Admin" &&
                                  payload?.servicesType !== "BenAdmin"),
                            ) === undefined
                          }
                          fullWidthRequired={true}
                        />
                      </>
                    ) : (
                      <>
                        <TopNavSmallButton
                          btnText={
                            <>
                              {" "}
                              Edit <br /> account
                            </>
                          }
                          handleFunction={() => {
                            if (payload?.type !== "bene_account_detail_modal") {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "BUAccount" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleModalOpen(id);
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "BUAccount",
                                  },
                                });
                              }
                            } else if (
                              payload.type === "bene_account_detail_modal"
                            ) {
                              actionRestricted();
                            }
                          }}
                          icon={ICONS?.EDIT_WITH_WHITE_CIRCLE}
                          enabledTextColor="var(--text-primary)"
                          enabledBgColor="var(--primary-nav-act)"
                          disabledBgColor="var(--primary-nav-act)"
                          hoverOption="white"
                          isDisabled={
                            payload.type === "bene_account_detail_modal" ||
                            viewAccountDetailData?.beneficiary_accounts[0]
                              ?.approval_status === "archived" ||
                            viewAccountDetailData?.beneficiary_accounts[0]
                              ?.approval_status === "blocked" ||
                            services?.find(
                              (service) =>
                                service === "BUAccount" ||
                                (service === "Admin" &&
                                  payload?.servicesType !== "BenAdmin"),
                            ) === undefined
                          }
                          fullWidthRequired={true}
                        />
                      </>
                    )}
                    <div className="flex">
                      <div className="flex-grow border-l border-solid border-primary-bg"></div>
                    </div>

                    {viewAccountDetailData?.beneficiary_accounts[0]
                      .approval_status === "blocked" ||
                    services?.find(
                      (service) =>
                        service === "BAAccountArchive" || service === "Admin",
                    ) === undefined ? (
                      <>
                        <TopNavSmallButton
                          btnText={label}
                          handleFunction={() => {
                            if (
                              viewAccountDetailData?.beneficiary_accounts[0]
                                .approval_status !== "blocked"
                            ) {
                              if (
                                services?.find(
                                  (service) =>
                                    service === "BAAccountArchive" ||
                                    service === "Admin",
                                ) !== undefined
                              ) {
                                handleUnarchive();
                                handleArchive();
                              } else {
                                navigate("/feature_not_assigned", {
                                  state: {
                                    unavailableService: "BAAccountArchive",
                                  },
                                });
                              }
                            }
                          }}
                          icon={
                            services?.find(
                              (service) =>
                                service === "BAAccountArchive" ||
                                service === "Admin",
                            ) === undefined &&
                            viewAccountDetailData?.beneficiary_accounts[0]
                              .approval_status === "archived"
                              ? ICONS?.UNARCHIVE
                              : ICONS?.ARCHIVE
                          }
                          enabledBgColor={"var(--primary-nav-act)"}
                          enabledTextColor={"var(--text-primary)"}
                          hoverOption="white"
                          isDisabled={
                            payload.type === "bene_account_detail_modal" ||
                            viewAccountDetailData?.beneficiary_accounts[0]
                              .approval_status === "blocked"
                          }
                          fullWidthRequired={true}
                        />
                      </>
                    ) : (
                      <TopNavSmallButton
                        btnText={
                          viewAccountDetailData?.beneficiary_accounts[0]
                            .approval_status === "archived" ? (
                            <>
                              Unarchive <br /> account{" "}
                            </>
                          ) : (
                            <>
                              Archive <br /> account{" "}
                            </>
                          )
                        }
                        handleFunction={() => {
                          if (payload?.type !== "bene_account_detail_modal") {
                            if (
                              services?.find(
                                (service) =>
                                  service === "BAAccountArchive" ||
                                  service === "Admin",
                              ) !== undefined
                            ) {
                              handleUnarchive();
                              handleArchive();
                            } else {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "BAAccountArchive",
                                },
                              });
                            }
                          } else if (
                            payload.type === "bene_account_detail_modal"
                          ) {
                            actionRestricted();
                          }
                        }}
                        icon={
                          viewAccountDetailData?.beneficiary_accounts[0]
                            .approval_status === "archived"
                            ? ICONS?.ARCHIVE
                            : ICONS?.UNARCHIVE
                        }
                        enabledBgColor={"var(--primary-nav-act)"}
                        enabledTextColor={"var(--text-primary"}
                        hoverOption="white"
                        isDisabled={
                          payload.type === "bene_account_detail_modal"
                        }
                        fullWidthRequired={true}
                      />
                    )}
                  </div>
                </div>
              </div>

              <div
                className={`bg-primary-bg flex-grow w-full ${payload.type === "bene_account_detail_modal" && "pb-padding-lg"}`}
              >
                <div className="  w-full bg-primary-card  ">
                  <div className=" w-full  lg:w-max-content-width m-auto">
                    {" "}
                    <CommonAlertsStrip alerts={buildAlerts()} />
                  </div>{" "}
                </div>

                <div className="h-auto max-w-tab-width-normal bg-primary-bg m-auto">
                  <div className="detail-category-button w-full ml-margin-md lg:ml-margin-base flex Qmd:pt-padding-md pb-padding-md lg:mx-auto Qmd:mx-margin-md Qlg:mx-margin-base">
                    <div
                      className="overflow-x-auto scroll-bar mt-margin-md Qsmd:mt-margin-base"
                      style={{ scrollbarWidth: "none" }}
                    >
                      <SwitcherTabs
                        tabs={[
                          {
                            label: "Details",
                            key: "Details",
                            handler: toggleContactDetails,
                          },
                          {
                            label: "Categories",
                            key: "Categories",
                            handler: toggleCategories,
                          },
                          {
                            label: "Labels",
                            key: "Labels",
                            handler: toggleAssignedLabels,
                          },
                          {
                            label: "Recipients",
                            key: "Recipients",
                            handler: toggleAdditionalRecipicent,
                          },
                        ]}
                        swicherTabBgColor={"var(--primary-card)"}
                        initialActiveTab={
                          showCategories
                            ? "Categories"
                            : showAssignedLabels
                              ? "Labels"
                              : additionalRecipient
                                ? "Recipients"
                                : ""
                        }
                        setIndex={setIndex}
                      />
                    </div>
                  </div>
                  <div className="relative">
                    {index === GlobalConfiguration?.lengthCheckZero && (
                      <div className={animationClass}>
                        {ViewAccountDetails?.map((account) => {
                          let originItemList = [
                            {
                              content: "+91 " + (account.contact_no ?? ""),
                              heading: "Contact number",
                              type: "text",
                            },
                            {
                              content: account?.email_id?.toLowerCase(),
                              heading: "Email ID",
                              type: "text",
                            },
                          ];

                          let AccountItemList = [
                            {
                              content: account?.pan_no,
                              heading: "PAN number",
                              type: "text",

                              onClick: () => {
                                const hasAccess = services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                );

                                if (hasAccess && account?.pan_no) {
                                  if (
                                    payload.type === "bene_account_detail_modal"
                                  ) {
                                    actionRestricted();
                                  } else {
                                    handlePANDetails(account.pan_no);
                                  }
                                } else {
                                  navigate("/feature_not_assigned", {
                                    state: { unavailableService: "VPAN" },
                                  });
                                }
                              },

                              isDisabled:
                                services?.some(
                                  (service) =>
                                    service === "VPAN" || service === "Admin",
                                ) &&
                                account?.pan_no &&
                                payload.type !== "bene_account_detail_modal"
                                  ? false
                                  : true,
                            },

                            {
                              content: account?.pan_legal_name
                                ?.toLowerCase()
                                ?.split(" ")
                                ?.map(
                                  (word) =>
                                    word
                                      .charAt(
                                        GlobalConfiguration?.lengthCheckZero,
                                      )
                                      .toUpperCase() +
                                    word.slice(
                                      GlobalConfiguration?.lengthCheckOne,
                                    ),
                                )
                                ?.join(" "),
                              heading: "Legal name",
                              type: "text",
                            },
                            {
                              content: account.gstin_detail
                                ? account.gstin_detail
                                : "Not Given",
                              heading: "GST number",
                              type: "text",

                              onClick: account?.gstin_detail
                                ? () => {
                                    if (
                                      payload.type ===
                                      "bene_account_detail_modal"
                                    ) {
                                      actionRestricted();
                                    } else {
                                      if (!account?.gstin_detail) return;

                                      const hasAccess =
                                        services?.includes("VGSTIN") ||
                                        services?.includes("Admin");
                                      if (hasAccess) {
                                        setGstShowPopup(true);
                                      } else {
                                        navigate("/feature_not_assigned", {
                                          state: {
                                            unavailableService: "VGSTIN",
                                          },
                                        });
                                      }
                                    }
                                  }
                                : undefined,
                            },
                          ];
                          let originTimelineItemList = [
                            {
                              content:
                                accountNameStandardised(
                                  account.created_by_name,
                                ) || "Not given",
                              heading: "Created by",
                              type: "text",
                            },
                            {
                              content: account.created_on
                                ? formatDateViewAll(
                                    account.created_on,
                                    true,
                                    true,
                                  )
                                : "Not given",
                              heading: "Created on",
                              type: "text",
                            },

                            // ✅ APPROVED
                            ...(account.approval_status === "approved"
                              ? [
                                  {
                                    content:
                                      account.approved_by_name || "Not given",
                                    heading: "Approved by",
                                    type: "text",
                                  },
                                  {
                                    content: account.approved_on
                                      ? formatDateViewAll(
                                          account.approved_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Approved on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ REJECTED
                            ...(account.approval_status === "rejected"
                              ? [
                                  {
                                    content:
                                      account.rejected_by_name || "Not given",
                                    heading: "Rejected by",
                                    type: "text",
                                  },
                                  {
                                    content: account.rejected_on
                                      ? formatDateViewAll(
                                          account.rejected_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Rejected on",
                                    type: "text",
                                  },
                                  {
                                    content:
                                      account.rejection_reason || "Not given",
                                    heading: "Rejected reason",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ ARCHIVED
                            ...(account.approval_status === "archived"
                              ? [
                                  {
                                    content:
                                      account.archived === "Y" &&
                                      !account.archived_by_name
                                        ? nameArchive
                                        : account.archived_by_name ||
                                          "Not given",
                                    heading: "Archived by",
                                    type: "text",
                                  },
                                  {
                                    content: account.archived_on
                                      ? formatDateViewAll(
                                          account.archived_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Archived on",
                                    type: "text",
                                  },
                                ]
                              : []),

                            // ✅ BLOCKED
                            ...(account.approval_status === "blocked"
                              ? [
                                  {
                                    content:
                                      account.blocked_by_name || "Not given",
                                    heading: "Blocked by",
                                    type: "text",
                                  },
                                  {
                                    content: account.blocked_on
                                      ? formatDateViewAll(
                                          account.blocked_on,
                                          true,
                                          true,
                                        )
                                      : "Not given",
                                    heading: "Blocked on",
                                    type: "text",
                                  },
                                ]
                              : []),
                          ];

                          let SupportInformationList = [
                            {
                              content: account.id,
                              heading: "Account ID",
                              type: "text",
                            },
                          ];

                          return (
                            <div className="flex flex-col lg:flex-row justify-around mb-margin-xl gap-gap-md mx-margin-md lg:mx-auto">
                              <CommonDetailCard
                                cardTitle="Contact Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Account Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={AccountItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Origin Details"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={originTimelineItemList}
                              />
                              <CommonDetailCard
                                cardTitle="Support Information"
                                numCols={GlobalConfiguration?.lengthCheckOne}
                                variant="fourth"
                                entries={SupportInformationList}
                              />
                            </div>
                          );
                        })}
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckOne && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ASSIGNED_BENEFICIARY_CATEGORIES}
                        >
                          {sliceCategory.filter((item) => item.active === "Y")
                            .length ===
                          viewAccountDetailData?.beneficiary_accounts?.[0]?.category.split(
                            ",",
                          ).length ? (
                            <div className="flex mb-margin-button-l items-center">
                              <img
                                className="w-icon-md h-icon-md mr-margin-sm"
                                src={ICONS?.ALERT}
                                alt="alert"
                              />
                              <p className="text-text-primary text-sm font-normal">
                                {TEXT?.ALL_CATEGORIES_ASSIGNED_WARNING}
                              </p>
                            </div>
                          ) : (
                            ""
                          )}
                          <div
                            className={`${
                              viewAccountDetailData?.beneficiary_accounts?.[0]
                                ?.category.length >
                              GlobalConfiguration?.lengthCheckZero
                                ? "assigned-beneficiary-categories-data-div"
                                : ""
                            }`}
                          >
                            {viewAccountDetailData?.beneficiary_accounts.map(
                              (account, index) => (
                                <div key={index}>
                                  <div className="flex flex-col Qmd:flex-row Qmd:flex-wrap gap-gap-sm">
                                    {account.category
                                      ? account.category
                                          .split(",")
                                          .map((category, categoryIndex) => (
                                            <div
                                              className="category-card max-w-none Qmd:max-w-detail-page-category-grid flex flex-row items-center"
                                              key={categoryIndex}
                                            >
                                              <div className="bene-category-img flex justify-center items-center opacity-base-opacity">
                                                <img
                                                  className="w-icon-lg h-icon-lg cateImage max-w-none"
                                                  src={categoryMapper(category)}
                                                  alt="bene"
                                                />
                                              </div>
                                              <div className="truncate px-padding-sm text-sm text-text-primary text-left font-sans font-semibold opacity-base-opacity antialiased">
                                                <TickerAnimation
                                                  text={category.trim()}
                                                />
                                              </div>
                                            </div>
                                          ))
                                      : null}
                                  </div>
                                  {!account.category && (
                                    <p
                                      key={`notFound_${index}`}
                                      className="antialiased text-text-primary text-sm"
                                    >
                                      {TEXT?.ASSIGN_CATEGORY_WARNING}
                                    </p>
                                  )}
                                </div>
                              ),
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}

                    {index === GlobalConfiguration?.lengthCheckTwo && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header="Assigned Labels"
                          subheader="Labels will be used to generate statistics for the
                                              associated accounts."
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (
                              !services?.includes("ALabel") &&
                              !services?.includes("RLabel")
                            ) {
                              navigate("/feature_not_assigned", {
                                state: {
                                  unavailableService: "ALabel,RLabel",
                                },
                              });
                              return;
                            }
                            if (payload?.type === "bene_account_detail_modal") {
                              actionRestricted();
                              return;
                            }
                            if (!isArchived) {
                              setShowLabelsPopup(true);
                            }
                          }}
                          icon={ICONS?.EDIT}
                          iconIsDisabled={
                            payload?.type === "bene_account_detail_modal"
                              ? true
                              : isArchived
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(labelDetails) &&
                            labelDetails.length >
                              GlobalConfiguration.lengthCheckZero ? (
                              <>
                                {labelDetails.map((item, index) => (
                                  <div
                                    key={index}
                                    className="px-padding-button-l py-padding-button-m flex rounded-border-radius-md bg-primary-nav max-w-full"
                                  >
                                    <div className="text-text-primary text-font-xs inline-block truncate">
                                      {item}
                                    </div>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <p className="text-font-sm text-text-primary">
                                No labels assigned.
                              </p>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                    {index === GlobalConfiguration?.lengthCheckThree && (
                      <div className={animationClass}>
                        <CommonContainerCard
                          header={TEXT?.ADDITIONAL_RECIPIENTS}
                          subheader={TEXT?.ADDITIONAL_RECIPIENTS_CARD_SUBTEXT}
                          icon={ICONS?.EDIT}
                          handleFunction={(e) => {
                            e.stopPropagation();
                            if (payload?.type === "bene_account_detail_modal") {
                              actionRestricted();
                              return;
                            }
                            if (!ensureAll(["BUAccount"]).status) {
                              navigate("/feature_not_assigned", {
                                state: { unavailableService: "BUAccount" },
                              });
                              return;
                            }
                            if (
                              ViewAccountDetails[0].approval_status ===
                                "archived" ||
                              ViewAccountDetails[0].approval_status ===
                                "blocked"
                            ) {
                              return;
                            } else {
                              setShowAdditionalSection(true);
                              setAdditionalChip(showAdditionalRecipient);
                            }
                          }}
                          iconIsDisabled={
                            !ensureAll(["BUAccount"]).status
                              ? true
                              : ViewAccountDetails[0].approval_status ===
                                    "archived" ||
                                  ViewAccountDetails[0].approval_status ===
                                    "blocked"
                                ? true
                                : payload?.type === "bene_account_detail_modal"
                                  ? true
                                  : false
                          }
                        >
                          <div className="flex flex-wrap w-full gap-gap-sm">
                            {Array.isArray(showAdditionalRecipient) &&
                            showAdditionalRecipient.length >
                              GlobalConfiguration?.lengthCheckZero ? (
                              <>
                                {showAdditionalRecipient.map((item, index) => (
                                  <div
                                    key={index}
                                    className="flex flex-row items-center py-padding-button-m px-padding-button-l rounded-border-radius-md relative bg-primary-nav-act max-w-max_width-full"
                                  >
                                    <span className="text-text-primary text-font-xs font-normal truncate">
                                      {linkIdentifier(item)}
                                    </span>
                                  </div>
                                ))}
                              </>
                            ) : (
                              <span className="text-text-primary text-sm font-normal">
                                {TEXT?.NO_ADDITIONAL_RECIPIENTS_ADDED}
                              </span>
                            )}
                          </div>
                        </CommonContainerCard>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default BeneficiaryAccountDetails;
